import React, { useState, useEffect, useRef } from "react";
import {
  AppBar,
  RadioGroup,
  Tabs,
  Tab,
  Paper,
  Typography,
  List,
  ListItem,
  ListItemText,
  Box,
  ListItemButton,
  Card,
  CardContent,
  FormControl,
  FormControlLabel,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Radio,
  Container,
  Link,
  Button,
  CircularProgress,
  Divider,
  Chip,
  IconButton,
  TextField,
} from "@mui/material";
import {
  CloudUpload,
  GetApp,
  Delete,
  InsertDriveFile,
  Description,
} from "@mui/icons-material";
import {
  LineChart,
  Line,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import Avatar from "@mui/material/Avatar";
import { TabPanel, a11yProps } from "./TabPanel"; // You need to define TabPanel and a11yProps
import axios from "axios";
// import CornAdminPage from "./CornAdminPage.js";
import DeleteIcon from "@mui/icons-material/Delete";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import DoneIcon from "@mui/icons-material/Done";
import EditIcon from "@mui/icons-material/Edit";
import EditOffIcon from "@mui/icons-material/EditOff";
import AdminRegistrationForm from "./AdminRegistrationForm";
import { useNavigate } from "react-router-dom";
import AdminList from "./AdminList";
import { saveAs } from "file-saver";
import profileImage from "./profile.jpg";
import NotificationMessage from "./NotificationMessage";
import CornContractPrices from "./CornContractPrices";
import RainfallChart from "./weatherChart";

function CornAdminPage({ showSuperAdminFeatures = false }) {
  const teamName = localStorage.getItem("username");
  const token = localStorage.getItem("token");
  const [value, setValue] = useState(0);
  const [value1, setValue1] = useState(0);
  const [cornUsers, setCornUsers] = useState([]);
  const [isCornUsersLoading, setIsCornUsersLoading] = useState(false);
  const [cornUsersError, setCornUsersError] = useState("");
  const [cottonUsers, setCottonUsers] = useState([]); // Change to cottonUsers
  const [selectedUser, setSelectedUser] = useState(null);
  const [submittedHybridForms, setSubmittedHybridForms] = useState([]);
  const [hybridTagImages, setHybridTagImages] = useState({});
  const [submittedCottonHybridForms, setSubmittedCottonHybridForms] = useState(
    [],
  );
  const [seedingsubmittedForms, setseedingSubmittedForms] = useState([]);
  const [seedingcottonsubmittedForms, setseedingcottonSubmittedForms] =
    useState([]);
  const [NitrogentableData, setNitrogenTableData] = useState([]);
  const [NitrogenCottontableData, setNitrogenCottonTableData] = useState([]);
  const [Irrigationapplications, setIrrigationApplications] = useState([]);
  const [IrrigationCottonapplications, setIrrigationCottonApplications] =
    useState([]);
  const [InsuranceFormData, setInsuranceFormData] = useState([]);
  const [InsuranceCottonFormData, setInsuranceCottonFormData] = useState([]);
  const [marketingOptions, setMarketingOptions] = useState([]);
  const [marketingCottonOptions, setMarketingCottonOptions] = useState([]);
  const [growthRegulationCotton, setGrowthRegulationCotton] = useState([]);

  const [defaultfiles, setDefaultFiles] = useState([]);
  const [insurancefiles, setInsuranceFiles] = useState([]);
  const [marketingfiles, setMarketingFiles] = useState([]);
  const [cottondefaultfiles, setCottonDefaultFiles] = useState([]);
  const [cottoninsurancefiles, setCottonInsuranceFiles] = useState([]);
  const [cottonmarketingfiles, setCottonMarketingFiles] = useState([]);
  const [fileInput, setFileInput] = useState(null);
  const [showAdminPage, setShowAdminPage] = useState(false);
  // const username = localStorage.getItem("username");
  const [showFileManagement, setShowFileManagement] = useState(false);
  const [showMarketingPrices, setShowMarketingPrices] = useState(false);
  const [profileImageUrl, setProfileImageUrl] = useState(profileImage);
  const [deleteMessage, setDeleteMessage] = useState("");
  const [showDeleteMessage, setShowDeleteMessage] = useState(false);
  const [deleteStatusMessagem, setDeleteStatusMessagem] = useState("");
  const [deleteStatusMessagei, setDeleteStatusMessagei] = useState("");
  const [deleteStatusMessaged, setDeleteStatusMessaged] = useState("");
  const [deleteStatusMessaget, setDeleteStatusMessaget] = useState("");
  const [teamMembers, setTeamMembers] = useState([]);
  const [cottonteamMembers, setCottonTeamMembers] = useState([]);
  const [soilMoistureSensor, setSoilMoistureSensor] = useState("");
  const [isApplicationTypeConfirmed1, setIsApplicationTypeConfirmed1] =
    useState(false);
  const [selectedOption, setSelectedOption] = useState("");
  const [isApplicationTypeConfirmed, setIsApplicationTypeConfirmed] =
    useState(false);
  const [ApplicationType, setApplicationType] = useState("");
  const [isApplicationTypeConfirmedN, setIsApplicationTypeConfirmedN] =
    useState(false);
  const [uploadingFile, setUploadingFile] = useState(null);
  const [loadingDownload, setLoadingDownload] = useState({});
  let navigate = useNavigate();

  // Notification state
  const [notification, setNotification] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const showNotification = (message, severity = "success") => {
    setNotification({ open: true, message, severity });
  };

  const handleCloseNotification = () => {
    setNotification({ ...notification, open: false });
  };

  const [selectedFile, setSelectedFile] = useState(null);
  const [selectedFilei, setSelectedFilei] = useState(null);
  const [selectedFilem, setSelectedFilem] = useState(null);
  const [selectedFiled, setSelectedFiled] = useState(null);
  const [selectedSubFolder, setSelectedSubFolder] = useState(""); // New state for subfolder; no default to force explicit selection

  // Field Data states
  const [fieldDataTab, setFieldDataTab] = useState(0); // Sub-tab index for Field Data
  const [soilDataDate, setSoilDataDate] = useState("");
  const [soilDataNO3N12, setSoilDataNO3N12] = useState("");
  const [soilDataNO3N24, setSoilDataNO3N24] = useState("");
  const [soilDataNO3N36, setSoilDataNO3N36] = useState("");
  const [plantTissueDate, setPlantTissueDate] = useState("");
  const [plantTissueN, setPlantTissueN] = useState("");
  const [plantTissueP, setPlantTissueP] = useState("");
  const [plantTissueK, setPlantTissueK] = useState("");

  // File upload states for field data
  const [fieldDataFile, setFieldDataFile] = useState(null);
  const [uploadingFieldData, setUploadingFieldData] = useState(false);
  const [parsedFieldData, setParsedFieldData] = useState(null);
  const [soilDataList, setSoilDataList] = useState([]);
  const [plantTissueDataList, setPlantTissueDataList] = useState([]);
  const [failedImages, setFailedImages] = useState({});

  // State for field data visualization (for selected user)
  const [userSoilData, setUserSoilData] = useState([]);
  const [userPlantTissueData, setUserPlantTissueData] = useState([]);
  const soilChartScrollRef = useRef(null);
  const plantTissueChartScrollRef = useRef(null);

  const handleDownload = (filePath) => {
    const fileName = decodeURIComponent(filePath.split("/").pop());
    setLoadingDownload((prev) => ({ ...prev, [fileName]: true }));

    axios
      .get(`/api/${filePath}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        responseType: "blob",
      })
      .then((response) => {
        const contentDisposition = response.headers["content-disposition"];
        let resolvedFileName = fileName;
        if (contentDisposition) {
          const matches = contentDisposition.match(/filename="([^"]+)"/);
          if (matches?.length === 2) {
            resolvedFileName = matches[1];
          }
        }
        saveAs(new Blob([response.data]), resolvedFileName);
      })
      .catch((error) => {
        console.error("Download error:", error);
      })
      .finally(() => {
        setLoadingDownload((prev) => ({ ...prev, [fileName]: false }));
      });
  };

  const fetchTeamMembers = async () => {
    setTeamMembers([]);
    if (selectedUser) {
      const teamId = selectedUser.id; // Assuming selectedUser.id contains the ID of the team
      axios
        .post(
          "/api/cornTeamMembers",
          {
            id: teamId, // Access the team ID from cornuser[0]
          },
          {
            headers: {
              Authorization: `Bearer ${token}`, // Include the token in the Authorization header
            },
          },
        )
        .then((response) => {
          // Handle the fetched team members data, e.g., set it in state
          console.log(response.data);
          setTeamMembers(response.data);
        })

        .catch((error) => {
          setTeamMembers([]);
          console.error("Failed to fetch team members:", error);
          // Handle errors, for example, by showing an error message in the UI
        });
    }
  };

  const fetchCottonTeamMembers = async () => {
    setCottonTeamMembers([]);
    if (selectedUser) {
      const teamId = selectedUser.id; // Assuming selectedUser.id contains the ID of the team
      axios
        .post(
          "/api/cottonTeamMembers",
          {
            id: teamId, // Access the team ID from cornuser[0]
          },
          {
            headers: {
              Authorization: `Bearer ${token}`, // Include the token in the Authorization header
            },
          },
        )
        .then((response) => {
          // Handle the fetched team members data, e.g., set it in state
          console.log(response.data);
          setCottonTeamMembers(response.data);
        })

        .catch((error) => {
          setCottonTeamMembers([]);
          console.error("Failed to fetch team members:", error);
          // Handle errors, for example, by showing an error message in the UI
        });
    }
  };

  useEffect(() => {
    if (selectedUser) {
      generateImageUrl();
      fetchTeamMembers();
      fetchApplicationTypeConfirmation();
      fetchApplicationTypeConfirmation1();
      fetchApplicationTypeConfirmationN();
    }
  }, [selectedUser]);

  const handleCloseAdminPage = () => {
    setShowAdminPage(false);
  };

  // Handler for file selection
  const handleFileChange = (event) => {
    setSelectedFile(event.target.files[0]);
  };

  const handleMarketingFileChange = (event) => {
    setSelectedFilem(event.target.files[0]);
  };

  // Field Data File Upload Handler
  const handleFieldDataFileUpload = async (dataType) => {
    if (!fieldDataFile) {
      showNotification("Please select a file to upload.", "warning");
      return;
    }

    setUploadingFieldData(true);
    const formData = new FormData();
    formData.append("file", fieldDataFile);
    formData.append("dataType", dataType); // 'plantTissue' or 'soil'
    formData.append("cropType", "corn"); // For corn admin page

    try {
      const response = await axios.post(
        "/api/uploadPlantTissueData",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      if (response.data.success) {
        showNotification(
          `Successfully processed ${response.data.insertedCount} teams!`,
          "success",
        );
        setParsedFieldData(response.data.parsedData);
        setFieldDataFile(null);

        // Log the parsed data for review
        console.log("Parsed Field Data:", response.data.parsedData);
      } else {
        showNotification(
          "Error uploading file: " + response.data.error,
          "error",
        );
      }
    } catch (error) {
      console.error("Error uploading field data file:", error);
      showNotification(
        "Error uploading file: " +
          (error.response?.data?.error || error.message),
        "error",
      );
    } finally {
      setUploadingFieldData(false);
    }
  };

  const handleFieldDataFileChange = (event) => {
    setFieldDataFile(event.target.files[0]);
    setParsedFieldData(null); // Reset parsed data when new file is selected
  };

  const handleInsuranceFileChange = (event) => {
    setSelectedFilei(event.target.files[0]);
  };

  const handleDefaultFileChange = (event) => {
    setSelectedFiled(event.target.files[0]);
  };

  const handleAdminRegistration = () => {
    setShowAdminPage(!showAdminPage);
  };

  const [selectedFile1, setSelectedFile1] = useState(null);

  // Handler for file selection
  const handleFileChange1 = (event) => {
    setSelectedFile1(event.target.files[0]);
  };

  const handleTeamFileDelete = (fileName, teamName) => {
    const encodedFileName = fileName
      .split("/")
      .map(encodeURIComponent)
      .join("/");
    axios
      .delete(
        `/api/deleteTeamFile/${encodeURIComponent(teamName)}/${encodedFileName}`,
        {
          headers: {
            Authorization: `Bearer ${token}`, // Include the token in the Authorization header
          },
        },
      )
      .then((response) => {
        if (response.status === 200) {
          // Handle successful deletion
          setDeleteStatusMessaget("File deleted successfully."); // Set success message
          // Optionally, clear the message after a delay
          setTimeout(() => setDeleteStatusMessaget(""), 3000);
          // Refresh the file list
          fetchFiles(teamName);
        }
      })
      .catch((error) => {
        // Handle error
        console.error("Error deleting file:", error);
        setDeleteStatusMessaget("Error deleting file."); // Set error message
        setTimeout(() => setDeleteStatusMessaget(""), 3000);
      });
  };

  const handleCottonTeamFileDelete = (fileName, teamName) => {
    const encodedFileName = fileName
      .split("/")
      .map(encodeURIComponent)
      .join("/");
    axios
      .delete(
        `/api/deleteCottonTeamFile/${encodeURIComponent(teamName)}/${encodedFileName}`,
        {
          headers: {
            Authorization: `Bearer ${token}`, // Include the token in the Authorization header
          },
        },
      )
      .then(() => {
        console.log("File deleted successfully");
        showNotification("File deleted successfully", "success");
        // Update the list to reflect the deletion
        fetchCottonFiles(teamName);
      })
      .catch((error) => {
        console.error("Error deleting file:", error);
        showNotification("Error deleting file", "error");
      });
  };

  const generateImageUrl = () => {
    if (selectedUser) {
      // Determine the crop based on the value
      const crop = value === 0 ? "corn" : value === 1 ? "cotton" : "";
      const imageUrl = `/uploads/${crop}/${selectedUser.teamName}/profile.jpg`;
      fetch(imageUrl)
        .then((response) => {
          if (response.ok) {
            setProfileImageUrl(imageUrl);
          } else {
            setProfileImageUrl("./profile.jpg"); // Path to your generic image
          }
        })
        .catch(() => {
          setProfileImageUrl("./profile.jpg"); // Path to your generic image
        });
      fetchProfileImage();
    }
  };
  // If either selectedUser or crop is not set, return a default image URL

  // Use the generateImageUrl function to set the imageUrl
  // const imageUrl = generateImageUrl();

  // Handler for file upload
  const handleteamFileUpload = (teamName) => {
    // const selectedFile = document.getElementById("defaultFileInput1").files[0];

    // Check if a file is selected

    if (!selectedFile) {
      showNotification("Please select a file to upload.", "warning");
      return;
    }

    if (!selectedSubFolder) {
      showNotification("Please select a category before uploading.", "warning");
      return;
    }

    const formData = new FormData();
    formData.append("file", selectedFile);
    formData.append("teamName", teamName); // Assuming teamName is passed as a prop or from state
    formData.append("cropType", "corn"); // Assuming cropType is passed as a prop or from state
    formData.append("subFolder", selectedSubFolder); // Add subfolder to form data

    axios
      .post("/api/upload", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`, // Include the token in the Authorization header
        },
      })
      .then((response) => {
        console.log("File uploaded successfully:", response.data);
        showNotification("Team file uploaded successfully", "success");

        // Clear the selected file
        setSelectedFile(null);
        document.getElementById("defaultFileInput1").value = "";
        setSelectedSubFolder(""); // Force explicit category selection for the next upload

        // Refresh the file list to show the newly uploaded file
        if (selectedUser) {
          console.log("Refreshing files for:", selectedUser.teamName); // Debug log
          fetchFiles(selectedUser.teamName);
        }
      })
      .catch((error) => {
        console.error("Error uploading file:", error);
        showNotification("Error uploading file", "error");
      });
  };

  const handleteamFileUpload1 = (teamName) => {
    // const selectedFile = document.getElementById("defaultFileInput1").files[0];

    // Check if a file is selected

    if (!selectedFile1) {
      showNotification("Please select a file to upload.", "warning");
      return;
    }

    const formData1 = new FormData();
    formData1.append("file", selectedFile1);
    formData1.append("teamName", teamName); // Assuming teamName is passed as a prop or from state
    formData1.append("cropType", "cotton"); // Assuming cropType is passed as a prop or from state

    axios
      .post("/api/upload", formData1, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`, // Include the token in the Authorization header
        },
      })
      .then((response) => {
        console.log("File uploaded successfully:", response.data);
        showNotification("Team file uploaded successfully", "success");
        setSelectedFiled(null);
        // Refresh the file list
        if (selectedUser) {
          fetchFiles(selectedUser.teamName);
        }

        // Remove the selected file from the input
        document.getElementById("defaultFileInput2").value = "";

        // Remove the success message after 3 seconds (3000 milliseconds)
        setTimeout(() => {
          successMessage.remove();
        }, 3000);
      })
      .catch((error) => {
        console.error("Error uploading file:", error);
        // Handle errors here (e.g., display an error message)
      });
  };

  const handleinsuranceDelete = (fileName) => {
    axios
      .delete(`/api/deleteinsuranceFile/${fileName}`, {
        headers: {
          Authorization: `Bearer ${token}`, // Include the token in the Authorization header
        },
      })
      .then((response) => {
        if (response.status === 200) {
          // Handle successful deletion
          setDeleteStatusMessagei("File deleted successfully."); // Set success message
          // Optionally, clear the message after a delay
          setTimeout(() => setDeleteStatusMessagei(""), 3000);
          // Refresh the file list
          fetchInsuranceFiles();
        }
      })
      .catch((error) => {
        // Handle error
        console.error("Error deleting file:", error);
        setDeleteStatusMessagei("Error deleting file."); // Set error message
        setTimeout(() => setDeleteStatusMessagei(""), 3000);
      });
  };

  const handlemarketingDelete = (fileName) => {
    axios
      .delete(`/api/deletemarketingFile/${fileName}`, {
        headers: {
          Authorization: `Bearer ${token}`, // Include the token in the Authorization header
        },
      })
      .then((response) => {
        if (response.status === 200) {
          // Handle successful deletion
          setDeleteStatusMessagem("File deleted successfully."); // Set success message
          // Optionally, clear the message after a delay
          setTimeout(() => setDeleteStatusMessagem(""), 3000);
          // Refresh the file list
          fetchMarketingFiles();
        }
      })
      .catch((error) => {
        // Handle error
        console.error("Error deleting file:", error);
        setDeleteStatusMessagem("Error deleting file."); // Set error message
        setTimeout(() => setDeleteStatusMessagem(""), 3000);
      });
  };

  const handledefaultDelete = (fileName) => {
    axios
      .delete(`/api/deletedefaultFile/${fileName}`, {
        headers: {
          Authorization: `Bearer ${token}`, // Include the token in the Authorization header
        },
      })
      .then((response) => {
        if (response.status === 200) {
          // Handle successful deletion
          setDeleteStatusMessaged("File deleted successfully."); // Set success message
          // Optionally, clear the message after a delay
          setTimeout(() => setDeleteStatusMessaged(""), 3000);
          // Refresh the file list
          fetchDefaultFiles();
        }
      })
      .catch((error) => {
        // Handle error
        console.error("Error deleting file:", error);
        setDeleteStatusMessaged("Error deleting file."); // Set error message
        setTimeout(() => setDeleteStatusMessaged(""), 3000);
      });
  };

  const handlecottoninsuranceDelete = (fileName) => {
    axios
      .delete(`/api/deletecottoninsuranceFile/${fileName}`, {
        headers: {
          Authorization: `Bearer ${token}`, // Include the token in the Authorization header
        },
      })
      .then((response) => {
        // Handle successful deletion
        console.log(response.data);
        showNotification(
          "Cotton insurance file deleted successfully",
          "success",
        );
      })
      .catch((error) => {
        // Handle error
        console.error("Error deleting file:", error);
        showNotification("Error deleting file", "error");
      });
  };

  const handlecottonmarketingDelete = (fileName) => {
    axios
      .delete(`/api/deletecottonmarketingFile/${fileName}`, {
        headers: {
          Authorization: `Bearer ${token}`, // Include the token in the Authorization header
        },
      })
      .then((response) => {
        // Handle successful deletion
        console.log(response.data);
        showNotification(
          "Cotton marketing file deleted successfully",
          "success",
        );
      })
      .catch((error) => {
        // Handle error
        console.error("Error deleting file:", error);
        showNotification("Error deleting file", "error");
      });
  };

  const handlecottondefaultDelete = (fileName) => {
    axios
      .delete(`/api/deletecottondefaultFile/${fileName}`, {
        headers: {
          Authorization: `Bearer ${token}`, // Include the token in the Authorization header
        },
      })
      .then((response) => {
        // Handle successful deletion
        console.log(response.data);
        showNotification("Cotton default file deleted successfully", "success");
      })
      .catch((error) => {
        // Handle error
        console.error("Error deleting file:", error);
        showNotification("Error deleting file", "error");
      });
  };

  const fetchApplicationTypeConfirmation = () => {
    setSelectedOption("");
    setIsApplicationTypeConfirmed(false);
    axios
      .get("/api/getIrrigationApplicationTypeConfirmation", {
        params: { teamName: selectedUser.teamName },
        headers: {
          Authorization: `Bearer ${token}`, // Include the token in the Authorization header
        },
      })
      .then((response) => {
        if (response.status === 200 && response.data) {
          // Assuming response.data has the structure { applicationType, isConfirmed }
          setSelectedOption(response.data.applicationType);
          setIsApplicationTypeConfirmed(response.data.isConfirmed);
        } else {
          setSelectedOption("");
          setIsApplicationTypeConfirmed(false);
          console.error("Application type confirmation not found");
        }
      })
      .catch((error) => {
        setSelectedOption("");
        setIsApplicationTypeConfirmed(false);
        console.error("Error fetching application type confirmation:", error);
      });
  };

  const fetchApplicationTypeConfirmationN = () => {
    setApplicationType("");
    setIsApplicationTypeConfirmed(false);
    axios
      .get("/api/getApplicationTypeConfirmation", {
        params: { teamName: selectedUser.teamName },
        headers: {
          Authorization: `Bearer ${token}`, // Include the token in the Authorization header
        },
      })
      .then((response) => {
        if (response.status === 200 && response.data) {
          // Assuming response.data has the structure { applicationType, isConfirmed }
          setApplicationType(response.data.applicationType);
          setIsApplicationTypeConfirmed(response.data.isConfirmed);
        } else {
          setApplicationType("");
          setIsApplicationTypeConfirmed(false);
          console.error("Application type confirmation not found");
        }
      })
      .catch((error) => {
        setApplicationType("");
        setIsApplicationTypeConfirmed(false);
        console.error("Error fetching application type confirmation:", error);
      });
  };

  const fetchApplicationTypeConfirmation1 = () => {
    setSoilMoistureSensor("");
    setIsApplicationTypeConfirmed1(false);
    axios
      .get("/api/getMoistureApplicationTypeConfirmation", {
        params: { teamName: selectedUser.teamName },
        headers: {
          Authorization: `Bearer ${token}`, // Include the token in the Authorization header
        },
      })
      .then((response) => {
        if (response.status === 200 && response.data) {
          // Assuming response.data has the structure { applicationType, isConfirmed }
          setSoilMoistureSensor(response.data.applicationType);
          setIsApplicationTypeConfirmed1(response.data.isConfirmed);
        } else {
          setSoilMoistureSensor("");
          setIsApplicationTypeConfirmed1(false);
          console.error("Sensor type confirmation not found");
        }
      })
      .catch((error) => {
        setSoilMoistureSensor("");
        setIsApplicationTypeConfirmed1(false);
        console.error("Error fetching sensor type confirmation:", error);
      });
  };

  const fetchProfileImage = () => {
    const profileImageUrlEndpoint = `/api/getProfileImageUrl/corn/${selectedUser.teamName}`;

    fetch(profileImageUrlEndpoint, {
      headers: {
        Authorization: `Bearer ${token}`, // Include the token in the Authorization header
      },
    })
      .then((response) => response.text()) // Assuming the response is plain text containing the image URL
      .then((imageUrl) => {
        // Backend returns 'uploads/2026/...' but static route is '/uploads'
        const correctedUrl = imageUrl.replace("uploads/2026", "/uploads/2026");
        setProfileImageUrl(correctedUrl);
      })
      .catch(() => {
        setProfileImageUrl("./profile.jpg"); // Path to your generic image
      });
  };

  const fetchDefaultFiles = () => {
    axios
      .get("/api/listdefaultFiles", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        if (response.status === 200) {
          setDefaultFiles(response.data.files);
        } else {
          console.error("Failed to fetch files from the backend");
        }
      })
      .catch((error) => {
        console.error("Error fetching files:", error);
      });
  };

  useEffect(() => {
    fetchDefaultFiles();
  }, []);

  const fetchInsuranceFiles = () => {
    axios
      .get("/api/listInsuranceFiles", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        if (response.status === 200) {
          setInsuranceFiles(response.data.files);
        } else {
          console.error("Failed to fetch files from the backend");
        }
      })
      .catch((error) => {
        console.error("Error fetching files:", error);
      });
  };

  useEffect(() => {
    fetchInsuranceFiles();
  }, []);

  const fetchMarketingFiles = () => {
    axios
      .get("/api/listMarketingFiles", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        if (response.status === 200) {
          setMarketingFiles(response.data.files);
        } else {
          console.error("Failed to fetch files from the backend");
        }
      })
      .catch((error) => {
        console.error("Error fetching files:", error);
      });
  };

  useEffect(() => {
    fetchMarketingFiles();
  }, []);

  // useEffect(() => {
  //   // Fetch the list of files when the component mounts
  //   axios
  //     .get("/api/listCottonDefaultFiles", {
  //       headers: {
  //         Authorization: `Bearer ${token}`, // Include the token in the Authorization header
  //       },
  //     })
  //     .then((response) => {
  //       if (response.status === 200) {
  //         setCottonDefaultFiles(response.data.files);
  //       } else {
  //         console.error("Failed to fetch files from the backend");
  //       }
  //     })
  //     .catch((error) => {
  //       console.error("Error fetching files:", error);
  //     });
  // }, []);

  // useEffect(() => {
  //   // Fetch the list of files when the component mounts
  //   axios
  //     .get("/api/listCottonInsuranceFiles", {
  //       headers: {
  //         Authorization: `Bearer ${token}`, // Include the token in the Authorization header
  //       },
  //     })
  //     .then((response) => {
  //       if (response.status === 200) {
  //         setCottonInsuranceFiles(response.data.files);
  //       } else {
  //         console.error("Failed to fetch files from the backend");
  //       }
  //     })
  //     .catch((error) => {
  //       console.error("Error fetching files:", error);
  //     });
  // }, []);

  // useEffect(() => {
  //   // Fetch the list of files when the component mounts
  //   axios
  //     .get("/api/listCottonMarketingFiles", {
  //       headers: {
  //         Authorization: `Bearer ${token}`, // Include the token in the Authorization header
  //       },
  //     })
  //     .then((response) => {
  //       if (response.status === 200) {
  //         setCottonMarketingFiles(response.data.files);
  //       } else {
  //         console.error("Failed to fetch files from the backend");
  //       }
  //     })
  //     .catch((error) => {
  //       console.error("Error fetching files:", error);
  //     });
  // }, []);

  const handleChange = (event, newValue) => {
    setValue(newValue);
    setSelectedUser(null);
  };

  const handleChange1 = (event, newValue) => {
    setValue1(newValue);
  };

  const handleChange2 = (event, newValue) => {
    setValue1(newValue);
  };

  const [teamfiles, setTeamFiles] = useState([]);

  const fetchFiles = async (teamName) => {
    setTeamFiles([]); // Clear previous files first
    try {
      const response = await axios.get(`/api/listTeamFiles/${teamName}`, {
        headers: {
          Authorization: `Bearer ${token}`, // Include the token in the Authorization header
        },
      });
      console.log("Fetched team files:", response.data.files); // Debug log
      setTeamFiles(response.data.files || []);
    } catch (error) {
      console.error("Error fetching team files:", error);
      console.error("Response:", error.response?.data); // Debug log
      setTeamFiles([]); // Ensure empty array on error
    }
  };

  const [cottonteamfiles, setCottonTeamFiles] = useState([]);

  const fetchCottonFiles = async (teamName) => {
    try {
      const response = await axios.get(`/api/listCottonTeamFiles/${teamName}`, {
        headers: {
          Authorization: `Bearer ${token}`, // Include the token in the Authorization header
        },
      });
      setCottonTeamFiles(response.data.files);
    } catch (error) {
      console.error("Error fetching files:", error);
      // Handle error appropriately
    }
  };

  const handleUserClick = (user) => {
    setSelectedUser(user);
    fetchFiles(user.teamName);
  };

  const handleUserClick1 = (user) => {
    setSelectedUser(user);
    fetchCottonFiles(user.teamName);
  };

  const handleDeleteNitrogenApplication = (appId) => {
    axios
      .delete(`/api/deletenitrogenApplication/${appId}`, {
        headers: {
          Authorization: `Bearer ${token}`, // Include the token in the Authorization header
        },
      })
      .then((response) => {
        if (response.status === 200) {
          // Application deleted successfully, now update the table data
          fetchDataFromBackend();
        } else {
          console.error("Failed to delete the application");
        }
      })
      .catch((error) => {
        console.error("Error deleting the application:", error);
      });
  };

  const handleDeleteNitrogenApplication1 = (appId) => {
    axios
      .delete(`/api/deletecottonnitrogenApplication/${appId}`, {
        headers: {
          Authorization: `Bearer ${token}`, // Include the token in the Authorization header
        },
      })
      .then((response) => {
        if (response.status === 200) {
          // Application deleted successfully, now update the table data
          fetchNitrogenCottonDataFromBackend();
        } else {
          console.error("Failed to delete the application");
        }
      })
      .catch((error) => {
        console.error("Error deleting the application:", error);
      });
  };

  const handleChangeApplied = (appId) => {
    // Make a POST request to your Express.js route to update the "applied" field
    axios
      .post(
        `/api/updateApplied/${appId}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`, // Include the token in the Authorization header
          },
        },
      )
      .then((response) => {
        if (response.status === 200) {
          // Application deleted successfully, now update the table data
          // fetchData();
          fetchIrrigationData();
        } else {
          console.error("Failed to delete the application");
        }
      })
      .catch((error) => {
        // Handle any errors (e.g., show an error message)
        console.error("Error updating applied field:", error);
      });
  };

  const handleChangeApplied1 = (appId) => {
    // Make a POST request to your Express.js route to update the "applied" field
    axios
      .post(`/api/updateCottonApplied/${appId}`, {
        headers: {
          Authorization: `Bearer ${token}`, // Include the token in the Authorization header
        },
      })
      .then((response) => {
        if (response.status === 200) {
          // Application deleted successfully, now update the table data
          // fetchData();
          fetchCottonIrrigationData();
        } else {
          console.error("Failed to delete the application");
        }
      })
      .catch((error) => {
        // Handle any errors (e.g., show an error message)
        console.error("Error updating applied field:", error);
      });
  };

  const handleNitrogenChangeApplied = (appId) => {
    // Make a POST request to your Express.js route to update the "applied" field
    axios
      .post(
        `/api/updateNitrogenApplied/${appId}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`, // Include the token in the Authorization header
          },
        },
      )
      .then((response) => {
        if (response.status === 200) {
          // Application deleted successfully, now update the table data
          // fetchData();
          fetchDataFromBackend();
        } else {
          console.error("Failed to delete the application");
        }
      })
      .catch((error) => {
        // Handle any errors (e.g., show an error message)
        console.error("Error updating applied field:", error);
      });
  };

  const handleNitrogenChangeApplied1 = (appId) => {
    // Make a POST request to your Express.js route to update the "applied" field
    axios
      .post(`/api/updateCottonNitrogenApplied/${appId}`, {
        headers: {
          Authorization: `Bearer ${token}`, // Include the token in the Authorization header
        },
      })
      .then((response) => {
        if (response.status === 200) {
          // Application deleted successfully, now update the table data
          // fetchData();
          fetchNitrogenCottonDataFromBackend();
        } else {
          console.error("Failed to delete the application");
        }
      })
      .catch((error) => {
        // Handle any errors (e.g., show an error message)
        console.error("Error updating applied field:", error);
      });
  };

  // useEffect(() => {
  //   // Fetch the submitted hybrid forms data from your server
  //   // You can make an Axios GET request to your API endpoint
  //   axios
  //     .get("/api/getAllCottonSubmittedHybridForms", {
  //       headers: {
  //         Authorization: `Bearer ${token}`, // Include the token in the Authorization header
  //       },
  //     })
  //     .then((response) => {
  //       setSubmittedCottonHybridForms(response.data);
  //     })
  //     .catch((error) => {
  //       console.error("Error fetching submitted hybrid forms data:", error);
  //     });
  // }, []);

  // useEffect(() => {
  //   // Fetch the submitted hybrid forms data from your server
  //   // You can make an Axios GET request to your API endpoint
  //   axios
  //     .get("/api/cottonFetchAllGrowthRegulation", {
  //       headers: {
  //         Authorization: `Bearer ${token}`, // Include the token in the Authorization header
  //       },
  //     })
  //     .then((response) => {
  //       setGrowthRegulationCotton(response.data);
  //     })
  //     .catch((error) => {
  //       console.error("Error fetching submitted hybrid forms data:", error);
  //     });
  // }, []);

  function handleCottonInsuranceFileUpload() {
    // Get the selected insurance file from the file input
    const insuranceFile = document.getElementById("insuranceFileInput1")
      .files[0];

    // Check if a file is selected
    if (!insuranceFile) {
      showNotification("Please select an insurance file.", "warning");
      return;
    }

    // Create a FormData object to send the insurance file
    const insuranceFormData = new FormData();
    insuranceFormData.append("insuranceFile", insuranceFile);

    // Send a POST request to upload the insurance file
    fetch("/api/uploadCottonInsuranceFile", {
      method: "POST",
      body: insuranceFormData,
    })
      .then((response) => {
        if (response.ok) {
          console.log("Insurance file uploaded successfully");
          showNotification(
            "Cotton insurance file uploaded successfully",
            "success",
          );

          // Remove the selected file from the input
          const fileInput = document.getElementById("insuranceFileInput1");
          if (fileInput) fileInput.value = "";
        } else {
          console.error("Error uploading insurance file");
          showNotification("Error uploading insurance file", "error");
        }
      })
      .catch((error) => {
        console.error("Error uploading insurance file:", error);
        showNotification("Error uploading insurance file", "error");
      });
  }

  // Function to handle marketing options file upload
  function handleCottonMarketingOptionsFileUpload() {
    // Get the selected marketing options file from the file input
    const marketingOptionsFile = document.getElementById(
      "marketingOptionsFileInput1",
    ).files[0];

    // Check if a file is selected
    if (!marketingOptionsFile) {
      showNotification("Please select a marketing options file.", "warning");
      return;
    }

    // Create a FormData object to send the marketing options file
    const marketingOptionsFormData = new FormData();
    marketingOptionsFormData.append(
      "marketingOptionsFile",
      marketingOptionsFile,
    );

    // Send a POST request to upload the marketing options file
    fetch("/api/uploadCottonMarketingOptionsFile", {
      method: "POST",
      body: marketingOptionsFormData,
    })
      .then((response) => {
        if (response.ok) {
          console.log("Marketing options file uploaded successfully");
          showNotification(
            "Cotton marketing options file uploaded successfully",
            "success",
          );

          // Remove the selected file from the input
          const fileInput = document.getElementById(
            "marketingOptionsFileInput1",
          );
          if (fileInput) fileInput.value = "";
        } else {
          console.error("Error uploading marketing options file");
          showNotification("Error uploading marketing options file", "error");
        }
      })
      .catch((error) => {
        console.error("Error uploading marketing options file:", error);
        showNotification("Error uploading marketing options file", "error");
      });
  }

  // Function to handle marketing options file upload
  function handledefaultFileUpload() {
    // Get the selected marketing options file from the file input
    const cottondefaultFile = document.getElementById("defaultCottonFileInput")
      .files[0];

    // Check if a file is selected
    if (!cottondefaultFile) {
      showNotification("Please select a general file.", "warning");
      return;
    }

    // Create a FormData object to send the marketing options file
    const defaultData = new FormData();
    defaultData.append("cottondefaultFile", cottondefaultFile);

    // Send a POST request to upload the marketing options file
    fetch("/api/uploadCottonDefaultFile", {
      method: "POST",
      body: defaultData,
    })
      .then((response) => {
        if (response.ok) {
          console.log("cotton default file uploaded successfully");
          showNotification(
            "Cotton default file uploaded successfully",
            "success",
          );

          // Remove the selected file from the input
          const fileInput = document.getElementById("defaultCottonFileInput");
          if (fileInput) fileInput.value = "";
        } else {
          console.error("Error uploading cotton default file");
          showNotification("Error uploading cotton default file", "error");
        }
      })
      .catch((error) => {
        console.error("Error uploading cotton default file:", error);
        showNotification("Error uploading cotton default file", "error");
      });
  }

  function handlecorndefaultFileUpload() {
    // Get the selected marketing options file from the file input
    // const defaultFile = document.getElementById("defaultFileInput").files[0];

    // Check if a file is selected
    if (!selectedFiled) {
      showNotification("Please select a general file.", "warning");
      return;
    }

    // Create a FormData object to send the marketing options file
    const defaultData = new FormData();
    defaultData.append("file", selectedFiled);

    // Send a POST request to upload the marketing options file
    axios
      .post("/api/uploadDefaultFile", defaultData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`, // Include the token in the Authorization header
        },
      })
      .then((response) => {
        if (response.status === 200) {
          console.log("corn default file uploaded successfully");
          showNotification("Default file uploaded successfully", "success");
          setSelectedFiled(null);

          // Remove the selected file from the input
          const fileInput = document.getElementById("defaultFileInput");
          if (fileInput) fileInput.value = "";

          // Refresh the file list
          fetchDefaultFiles();
        }
      })
      .catch((error) => {
        console.error("Error uploading corn default file:", error);
        showNotification("Error uploading default file", "error");
      });
  }

  const handleDeleteApplication = (appId) => {
    axios
      .delete(`/api/deleteirrigationApplication/${appId}`, {
        headers: {
          Authorization: `Bearer ${token}`, // Include the token in the Authorization header
        },
      })
      .then((response) => {
        if (response.status === 200) {
          // Application deleted successfully, now update the table data
          // fetchData();
          fetchIrrigationData();
        } else {
          console.error("Failed to delete the application");
        }
      })
      .catch((error) => {
        console.error("Error deleting the application:", error);
      });
  };

  const handleDeleteApplication1 = (appId) => {
    axios
      .delete(`/api/deletecottonirrigationApplication/${appId}`, {
        headers: {
          Authorization: `Bearer ${token}`, // Include the token in the Authorization header
        },
      })
      .then((response) => {
        if (response.status === 200) {
          // Application deleted successfully, now update the table data
          // fetchData();
          fetchIrrigationData();
        } else {
          console.error("Failed to delete the application");
        }
      })
      .catch((error) => {
        console.error("Error deleting the application:", error);
      });
  };

  function handleFileUpload() {
    // Get the selected files from the file inputs
    const insuranceFile =
      document.getElementById("insuranceFileInput").files[0];
    const marketingOptionsFile = document.getElementById(
      "marketingOptionsFileInput",
    ).files[0];

    // Check if files are selected
    if (!insuranceFile || !marketingOptionsFile) {
      showNotification(
        "Please select both insurance and marketing options files.",
        "warning",
      );
      return;
    }

    // Create FormData objects to send the files
    const insuranceFormData = new FormData();
    insuranceFormData.append("insuranceFile", insuranceFile);

    const marketingOptionsFormData = new FormData();
    marketingOptionsFormData.append(
      "marketingOptionsFile",
      marketingOptionsFile,
    );

    // Send POST requests to upload the files (you can use Axios or other libraries)
    // Example using fetch:
    fetch(
      "/api/uploadInsuranceFile",
      {
        method: "POST",
        body: insuranceFormData,
      },
      {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`, // Include the token in the Authorization header
        },
      },
    )
      .then((response) => {
        if (response.ok) {
          console.log("Insurance file uploaded successfully");
        } else {
          console.error("Error uploading insurance file");
        }
      })
      .catch((error) => {
        console.error("Error uploading insurance file:", error);
      });

    fetch("/api/uploadMarketingOptionsFile", {
      method: "POST",
      body: marketingOptionsFormData,
    })
      .then((response) => {
        if (response.ok) {
          console.log("Marketing options file uploaded successfully");
        } else {
          console.error("Error uploading marketing options file");
        }
      })
      .catch((error) => {
        console.error("Error uploading marketing options file:", error);
      });
  }

  // Function to handle insurance file upload
  const handleInsuranceFileUpload = () => {
    // Get the selected insurance file from the file input
    // const insuranceFile =
    //   document.getElementById("insuranceFileInput").files[0];
    // Check if a file is selected
    if (!selectedFilei) {
      showNotification("Please select an insurance file.", "warning");
      return;
    }

    // Create a FormData object to send the insurance file
    const insuranceFormData = new FormData();
    insuranceFormData.append("file", selectedFilei);

    // Send a POST request to upload the insurance file
    axios
      .post("/api/uploadInsuranceFile", insuranceFormData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`, // Include the token in the Authorization header
        },
      })
      .then((response) => {
        if (response.status === 200) {
          console.log("Insurance file uploaded successfully");
          showNotification("Insurance file uploaded successfully", "success");
          setSelectedFilei(null);
          const fileInput = document.getElementById("insuranceFileInput");
          if (fileInput) fileInput.value = "";
          // Refresh the file list
          fetchInsuranceFiles();
        } else {
          showNotification("Error uploading insurance file", "error");
        }
      })
      .catch((error) => {
        console.error("Error uploading insurance file:", error);
        showNotification(
          "Error uploading insurance file: " +
            (error.response?.data?.message || error.message),
          "error",
        );
      });
  };

  // Function to handle marketing options file upload
  function handleMarketingOptionsFileUpload() {
    // Get the selected marketing options file from the file input
    // const marketingOptionsFile = document.getElementById(
    //   "marketingOptionsFileInput"
    // ).files[0];

    // Check if a file is selected
    if (!selectedFilem) {
      showNotification("Please select a marketing options file.", "warning");
      return;
    }

    // Create a FormData object to send the marketing options file
    const marketingOptionsFormData = new FormData();
    marketingOptionsFormData.append("file", selectedFilem);
    axios
      .post("/api/uploadMarketingOptionsFile", marketingOptionsFormData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`, // Include the token in the Authorization header
        },
      })
      // Send a POST request to upload the marketing options file

      .then((response) => {
        if (response.status === 200) {
          console.log("Marketing options file uploaded successfully");
          showNotification(
            "Marketing options file uploaded successfully",
            "success",
          );
          setSelectedFilem(null);
          const fileInput = document.getElementById(
            "marketingOptionsFileInput",
          );
          if (fileInput) fileInput.value = "";
          // Refresh the file list
          fetchMarketingFiles();
        } else {
          showNotification("Error uploading marketing options file", "error");
        }
      })
      .catch((error) => {
        console.error("Error uploading marketing options file:", error);
        showNotification(
          "Error uploading marketing options file: " +
            (error.response?.data?.message || error.message),
          "error",
        );
      });
  }

  const fetchCornUsers = async ({ silent = false } = {}) => {
    if (!token) {
      setCornUsers([]);
      setCornUsersError("Session expired. Please log in again.");
      return;
    }

    if (!silent) {
      setIsCornUsersLoading(true);
    }
    setCornUsersError("");

    let lastError = null;

    try {
      for (let attempt = 1; attempt <= 3; attempt++) {
        try {
          const response = await axios.get("/api/get_corn_users", {
            headers: {
              Authorization: `Bearer ${token}`,
            },
            timeout: 15000,
          });

          const users = Array.isArray(response.data) ? response.data : [];
          setCornUsers(users);
          return;
        } catch (error) {
          lastError = error;
          const status = error?.response?.status;
          const shouldRetry =
            attempt < 3 && (!status || status === 429 || status >= 500);

          if (shouldRetry) {
            await new Promise((resolve) => setTimeout(resolve, attempt * 800));
            continue;
          }

          break;
        }
      }

      setCornUsers([]);
      const status = lastError?.response?.status;
      if (status === 401 || status === 403) {
        setCornUsersError("Session expired. Please log in again.");
      } else {
        setCornUsersError(
          "Unable to load corn teams right now. Click Refresh to try again.",
        );
      }
      console.error("Error fetching Corn users data:", lastError);
    } finally {
      if (!silent) {
        setIsCornUsersLoading(false);
      }
    }
  };

  useEffect(() => {
    fetchCornUsers();
  }, [token]);

  // useEffect(() => {
  //   // Fetch users for the Cotton crop from the API (changed to cotton)
  //   axios
  //     .get("/api/get_cotton_users", {
  //       headers: {
  //         Authorization: `Bearer ${token}`, // Include the token in the Authorization header
  //       },
  //     })
  //     .then((response) => {
  //       setCottonUsers(response.data);
  //       console.log(response.data);
  //     })
  //     .catch((error) => {
  //       console.error("Error fetching Cotton users data:", error);
  //     });
  // }, []);

  const fetchHybridTagImage = async (teamName) => {
    if (!teamName) {
      console.warn("fetchHybridTagImage called with empty teamName");
      return;
    }

    try {
      console.log(`Fetching hybrid tag image for team: ${teamName}`);
      const response = await fetch(
        `/api/getHybridTagImageUrl/corn/${teamName}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      console.log(`Response status for ${teamName}:`, response.status);

      if (!response.ok) {
        console.error(`HTTP error for ${teamName}:`, response.status);
        return;
      }

      const imageUrl = await response.text();
      console.log(`Hybrid tag image URL for ${teamName}:`, imageUrl);

      if (imageUrl && imageUrl.trim() !== "") {
        setHybridTagImages((prev) => ({
          ...prev,
          [teamName]: imageUrl,
        }));
        console.log(`Set hybrid tag image for ${teamName}`);
      } else {
        console.log(`No image URL returned for ${teamName}`);
      }
    } catch (error) {
      console.error(`Error fetching hybrid tag image for ${teamName}:`, error);
    }
  };

  useEffect(() => {
    // Fetch the submitted hybrid forms data from your server
    // You can make an Axios GET request to your API endpoint
    axios
      .get("/api/getAllCornSubmittedHybridForms", {
        headers: {
          Authorization: `Bearer ${token}`, // Include the token in the Authorization header
        },
      })
      .then((response) => {
        setSubmittedHybridForms(response.data);
        // Fetch hybrid tag images for each team
        response.data.forEach((form) => {
          fetchHybridTagImage(form.teamName);
        });
      })
      .catch((error) => {
        console.error("Error fetching submitted hybrid forms data:", error);
      });
  }, []);

  // Fetch hybrid tag image when a user is selected
  useEffect(() => {
    if (selectedUser && selectedUser.teamName) {
      console.log(`Selected user changed to: ${selectedUser.teamName}`);
      fetchHybridTagImage(selectedUser.teamName);
    }
  }, [selectedUser]);

  useEffect(() => {
    // Fetch the submitted forms data for the logged-in user
    const fetchcornSeedingSubmittedForms = async () => {
      try {
        const response = await axios.get(
          "/api/getAllCornseedingForms",
          {
            headers: {
              Authorization: `Bearer ${token}`, // Include the token in the Authorization header
            },
          },
          // Send username as part of the request body
        );

        if (response.status === 200) {
          // Update the state with the fetched data
          setseedingSubmittedForms(response.data);
        } else {
          console.error("Failed to fetch submitted forms data");
        }
      } catch (error) {
        console.error("Error fetching submitted forms data:", error);
      }
    };

    //Call the fetch function when the component mounts
    fetchcornSeedingSubmittedForms();
  }, []);

  // useEffect(() => {
  //   // Fetch the submitted forms data for the logged-in user
  //   const fetchcottonSeedingSubmittedForms = async () => {
  //     try {
  //       const response = await axios.get(
  //         "/api/getAllCottonseedingForms",
  //         {
  //           headers: {
  //             Authorization: `Bearer ${token}`, // Include the token in the Authorization header
  //           },
  //         }
  //         // Send username as part of the request body
  //       );

  //       if (response.status === 200) {
  //         // Update the state with the fetched data
  //         setseedingcottonSubmittedForms(response.data);
  //       } else {
  //         console.error("Failed to fetch submitted forms data");
  //       }
  //     } catch (error) {
  //       console.error("Error fetching submitted forms data:", error);
  //     }
  //   };

  //   // Call the fetch function when the component mounts
  //   fetchcottonSeedingSubmittedForms();
  // }, []);

  useEffect(() => {
    // Fetch data from the backend when the component mounts
    fetchDataFromBackend();
  }, []); // Fetch data whenever applicationType changes

  const fetchDataFromBackend = () => {
    // Make an API request to fetch data from the backend based on the application type
    axios
      .get("/api/fetchAllNitrogenManagementData", {
        headers: {
          Authorization: `Bearer ${token}`, // Include the token in the Authorization header
        },
      })
      .then((response) => {
        if (response.status === 200) {
          // Set the retrieved data to the state variable
          console.log(response.data);
          setNitrogenTableData(response.data);
        } else {
          console.error("Failed to fetch data from the backend");
        }
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };

  // useEffect(() => {
  //   // Fetch data from the backend when the component mounts
  //   fetchNitrogenCottonDataFromBackend();
  // }, []);

  const fetchNitrogenCottonDataFromBackend = () => {
    // Make an API request to fetch data from the backend based on the application type
    axios
      .get("/api/cottonfetchAllNitrogenManagementData", {
        headers: {
          Authorization: `Bearer ${token}`, // Include the token in the Authorization header
        },
      })
      .then((response) => {
        if (response.status === 200) {
          // Set the retrieved data to the state variable
          console.log(response.data);
          setNitrogenCottonTableData(response.data);
        } else {
          console.error("Failed to fetch data from the backend");
        }
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };

  const fetchIrrigationData = () => {
    axios
      .get("/api/fetchAllSoilMoistureSensorData", {
        headers: {
          Authorization: `Bearer ${token}`, // Include the token in the Authorization header
        },
      }) // Update the URL accordingly
      .then((response) => {
        if (response.status === 200) {
          console.log(response.data);
          // Handle the successful response and update the state
          setIrrigationApplications(response.data);
        } else {
          console.error("Failed to fetch data from the backend");
        }
      })
      .catch((error) => {
        // Handle errors
        console.error("Error fetching data:", error);
      });
  };

  //Call the fetchData function when the component mounts
  useEffect(() => {
    fetchIrrigationData();
  }, []);

  const fetchCottonIrrigationData = () => {
    axios
      .get("/api/cottonfetchAllSoilMoistureSensorData", {
        headers: {
          Authorization: `Bearer ${token}`, // Include the token in the Authorization header
        },
      }) // Update the URL accordingly
      .then((response) => {
        // Handle the successful response and update the state
        setIrrigationCottonApplications(response.data);
      })
      .catch((error) => {
        // Handle errors
        console.error("Error fetching data:", error);
      });
  };

  // Call the fetchData function when the component mounts
  // useEffect(() => {
  //   fetchCottonIrrigationData();
  // }, []);

  const fetchInsuranceSelectionData = () => {
    axios
      .get("/api/getAllInsuranceSelectionForms", {
        headers: {
          Authorization: `Bearer ${token}`, // Include the token in the Authorization header
        },
      })
      .then((response) => {
        if (response.status === 200) {
          setInsuranceFormData(response.data);
        } else {
          console.error("Failed to fetch data from the backend");
        }
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };

  // Fetch existing insurance selection data for the user when the component mounts
  useEffect(() => {
    fetchInsuranceSelectionData();
  }, []);

  const fetchInsuranceCottonSelectionData = () => {
    axios
      .post("/api/cottongetAllInsuranceSelectionForms", {
        headers: {
          Authorization: `Bearer ${token}`, // Include the token in the Authorization header
        },
      })
      .then((response) => {
        if (response.status === 200) {
          setInsuranceCottonFormData(response.data);
        } else {
          console.error("Failed to fetch data from the backend");
        }
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };

  // Fetch existing insurance selection data for the user when the component mounts
  // useEffect(() => {
  //   fetchInsuranceCottonSelectionData();
  // }, []);

  const fetchMarketingDataFromBackend = () => {
    // Make an API request to fetch data from the backend
    axios
      .get("/api/fetchAllMarketingOptions", {
        headers: {
          Authorization: `Bearer ${token}`, // Include the token in the Authorization header
        },
      }) // Update the URL accordingly
      .then((response) => {
        if (response.status === 200) {
          // Set the retrieved data to the state variable
          setMarketingOptions(response.data);
        } else {
          console.error("Failed to fetch data from the backend");
        }
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };

  useEffect(() => {
    // Fetch data from the backend when the component mounts
    fetchMarketingDataFromBackend();
  }, []);

  const fetchMarketingCottonDataFromBackend = () => {
    // Make an API request to fetch data from the backend
    axios
      .get("/api/cottonfetchAllMarketingOptions", {
        headers: {
          Authorization: `Bearer ${token}`, // Include the token in the Authorization header
        },
      }) // Update the URL accordingly
      .then((response) => {
        if (response.status === 200) {
          // Set the retrieved data to the state variable
          setMarketingCottonOptions(response.data);
        } else {
          console.error("Failed to fetch data from the backend");
        }
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };

  // useEffect(() => {
  //   // Fetch data from the backend when the component mounts
  //   fetchMarketingCottonDataFromBackend();
  // }, []);

  // Fetch soil data for the selected user
  const fetchUserSoilData = () => {
    if (!selectedUser || !selectedUser.teamName) return;

    axios
      .get("/api/getSoilData", {
        params: { teamName: selectedUser.teamName, cropType: "corn" },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        if (response.data.success) {
          setUserSoilData(response.data.data || []);
        }
      })
      .catch((error) => {
        console.error("Error fetching user soil data:", error);
        setUserSoilData([]);
      });
  };

  // Fetch plant tissue data for the selected user
  const fetchUserPlantTissueData = () => {
    if (!selectedUser || !selectedUser.teamName) return;

    axios
      .get("/api/getPlantTissueData", {
        params: { teamName: selectedUser.teamName, cropType: "corn" },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        if (response.data.success) {
          setUserPlantTissueData(response.data.data || []);
        }
      })
      .catch((error) => {
        console.error("Error fetching user plant tissue data:", error);
        setUserPlantTissueData([]);
      });
  };

  // Fetch field data when user is selected or when Field Data tab is accessed
  useEffect(() => {
    if (selectedUser && value1 === 7) {
      fetchUserSoilData();
      fetchUserPlantTissueData();
    }
  }, [selectedUser, value1]);

  // Auto-scroll charts to show latest entry on mobile
  useEffect(() => {
    if (soilChartScrollRef.current && window.innerWidth < 768) {
      soilChartScrollRef.current.scrollLeft =
        soilChartScrollRef.current.scrollWidth;
    }
  }, [userSoilData]);

  useEffect(() => {
    if (plantTissueChartScrollRef.current && window.innerWidth < 768) {
      plantTissueChartScrollRef.current.scrollLeft =
        plantTissueChartScrollRef.current.scrollWidth;
    }
  }, [userPlantTissueData]);

  const tabLabels = [
    "User Info",
    "Hybrid",
    "Seeding",
    "Nitrogen Mgmnt",
    "Irrigation Mgmnt",
    "Insurance",
    "Marketing",
    "Field Data",
    "File Mgmnt",
    "Weather",
  ];

  const tabLabelsCotton = [
    "User Info",
    "Hybrid",
    "Seeding",
    "Nitrogen Mgmnt",
    "Irrigation Mgmnt",
    "Insurance",
    "Growth Regulator",
    "Marketing",
    "File Mgmnt",
  ];

  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const handleDeleteCottonUser = () => {
    // API call to delete the user
    const isFirstConfirmed = window.confirm(
      "Are you sure you want to delete this user?",
    );
    if (!isFirstConfirmed) return;

    // Second confirmation
    const isSecondConfirmed = window.confirm(
      "This action is irreversible. Are you absolutely sure?",
    );
    if (!isSecondConfirmed) return;
    axios
      .delete(`/api/deleteCottonUser/${selectedUser.id}`, {
        headers: {
          Authorization: `Bearer ${token}`, // Include the token in the Authorization header
        },
      })
      .then((response) => {
        console.log("User deleted successfully:", response);
        // Handle successful deletion (e.g., update state, show notification)
        setSuccessMessage("User deleted successfully.");
      })
      .catch((error) => {
        console.error("Error deleting user:", error);
        // Handle error (e.g., show error message)
        setErrorMessage("Failed to delete user.");
      });
  };

  const handleDeleteCornUser = () => {
    // API call to delete the user
    const isFirstConfirmed = window.confirm(
      "Are you sure you want to delete this user?",
    );
    if (!isFirstConfirmed) return;

    // Second confirmation
    const isSecondConfirmed = window.confirm(
      "This action is irreversible. Are you absolutely sure?",
    );
    if (!isSecondConfirmed) return;
    axios
      .delete(`/api/deleteCornUser/${selectedUser.id}`, {
        headers: {
          Authorization: `Bearer ${token}`, // Include the token in the Authorization header
        },
      })
      .then((response) => {
        console.log("User deleted successfully:", response);
        // Handle successful deletion (e.g., update state, show notification)
        setSuccessMessage("User deleted successfully.");
      })
      .catch((error) => {
        console.error("Error deleting user:", error);
        // Handle error (e.g., show error message)
        setErrorMessage("Failed to delete user.");
      });
  };

  const handleProfileClick = () => {
    navigate("/adminprofile");
  };

  const handleMarketingPricesClick = () => {
    setShowMarketingPrices(true);
  };

  const handleCloseMarketingPrices = () => {
    setShowMarketingPrices(false);
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      month: "2-digit",
      day: "2-digit",
      year: "numeric",
    });
  };

  // Show Marketing Prices view if enabled
  if (showMarketingPrices) {
    return (
      <div style={{ marginLeft: "20px" }}>
        <Button
          onClick={handleCloseMarketingPrices}
          variant="contained"
          color="primary"
          sx={{ mb: 2 }}
        >
          Back to Main Page
        </Button>
        <CornContractPrices />
      </div>
    );
  }

  return (
    <div>
      {/* <TabPanel value={value} index={0}> */}
      <div style={{ display: "flex" }}>
        <List
          component="nav"
          aria-label="Usernames"
          style={{
            minWidth: "200px",
            maxHeight: "calc(100vh - 150px)",
            overflowY: "auto",
            position: "sticky",
            top: "80px",
          }}
        >
          <ListItem
            style={{
              fontWeight: "bold",
              fontSize: "1.2rem",
              color: "Blue",
              position: "sticky",
              top: 0,
              backgroundColor: "white",
              zIndex: 1,
            }}
          >
            Corn Users
          </ListItem>
          {isCornUsersLoading && (
            <Typography sx={{ px: 2, py: 1, fontSize: "0.85rem" }}>
              Loading corn teams...
            </Typography>
          )}
          {cornUsersError && (
            <Typography
              color="error"
              sx={{ px: 2, py: 1, fontSize: "0.85rem" }}
            >
              {cornUsersError}
            </Typography>
          )}
          {!isCornUsersLoading && !cornUsersError && cornUsers.length === 0 && (
            <Typography sx={{ px: 2, py: 1, fontSize: "0.85rem" }}>
              No corn teams found.
            </Typography>
          )}
          {cornUsers.map((user, index) => (
            <ListItemButton
              key={index}
              onClick={() => handleUserClick(user)}
              sx={{
                my: 1,
                mx: 1.5,
                border:
                  selectedUser === user
                    ? "2px solid rgb(255, 255, 255)"
                    : "2px solid rgb(37, 106, 185)",
                backgroundColor: selectedUser === user ? "#fa4616" : "#F5F5F5",
                borderRadius: "8px",
                color: selectedUser === user ? "white" : "#333",
                boxShadow:
                  selectedUser === user
                    ? "0px 4px 10px rgba(0, 0, 0, 0.2)"
                    : "none",
                transition: "all 0.3s ease-in-out",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                textAlign: "center",
                "&:hover": {
                  backgroundColor:
                    selectedUser === user ? "#d73a12" : "#E0E0E0",
                  transform: "scale(1.05)",
                },
              }}
            >
              <ListItemText primary={user.teamName} />
            </ListItemButton>
          ))}
        </List>
        <div style={{ display: "flex", flexDirection: "column" }}>
          {!selectedUser && (
            <div>
              <Typography variant="h6" style={{ padding: "20px" }}>
                Please select a user from the list to view their details
              </Typography>
            </div>
          )}
          <Box ml={2}>
            {/* Add some spacing between list and user details */}
            {selectedUser && (
              <div>
                <div>
                  <AppBar position="static" color="default">
                    <Paper elevation={3}>
                      <Tabs
                        value={value1}
                        onChange={handleChange1}
                        aria-label="Admin Tabs"
                        variant="scrollable" // Allow tabs to scroll if many tabs are present
                        indicatorColor="secondary"
                        textColor="primary"
                      >
                        {tabLabels.map((label, index) => (
                          <Tab
                            label={label}
                            {...a11yProps(index)}
                            key={index}
                          />
                        ))}
                      </Tabs>
                    </Paper>
                  </AppBar>
                  <TabPanel value={value1} index={0}>
                    <h4>User Details</h4>
                    <Avatar
                      alt="Profile Image"
                      src={profileImageUrl} // Use the dynamically generated imageUrl
                      sx={{ width: 350, height: 350 }}
                      variant="rounded"
                    />
                    {successMessage && (
                      <h2 className="success-message">{successMessage}</h2>
                    )}
                    {errorMessage && (
                      <h2 className="success-message">{errorMessage}</h2>
                    )}
                    <p style={{ textAlign: "justify" }}>
                      Username: {selectedUser.teamName}
                    </p>{" "}
                    {/* Change to teamName */}
                    <p style={{ textAlign: "justify" }}>
                      Crop: {selectedUser.cropType}
                    </p>{" "}
                    <p style={{ textAlign: "justify" }}>
                      Captain First Name: {selectedUser.captainFirstName}
                    </p>{" "}
                    {/* Change to captainFirstName */}
                    <p style={{ textAlign: "justify" }}>
                      Captain Last Name: {selectedUser.captainLastName}
                    </p>{" "}
                    {/* Change to captainLastName */}
                    <p style={{ textAlign: "justify" }}>
                      Address 1: {selectedUser.address1}
                    </p>
                    <p style={{ textAlign: "justify" }}>
                      Address 2: {selectedUser.address2}
                    </p>
                    <p style={{ textAlign: "justify" }}>
                      City: {selectedUser.city}
                    </p>
                    <p style={{ textAlign: "justify" }}>
                      State: {selectedUser.state}
                    </p>
                    <p style={{ textAlign: "justify" }}>
                      Zip Code: {selectedUser.zipCode}
                    </p>
                    <p style={{ textAlign: "justify" }}>
                      Country: {selectedUser.country}
                    </p>
                    <p style={{ textAlign: "justify" }}>
                      Email: {selectedUser.email}
                    </p>{" "}
                    {/* Change to email */}
                    <p style={{ textAlign: "justify" }}>
                      Phone: {selectedUser.phone}
                    </p>{" "}
                    {/* Change to phone */}
                    {/* Display other user details here */}
                    <div>
                      <h4>Team Members</h4>
                      {teamMembers.length > 0 ? (
                        teamMembers.map((member, index) => (
                          <div key={index}>
                            {/* Customize your team member display here */}
                            <p style={{ textAlign: "justify" }}>
                              Name: {member.name}
                            </p>
                            <p style={{ textAlign: "justify" }}>
                              Email: {member.email}
                            </p>
                            {/* Add more details as needed */}
                          </div>
                        ))
                      ) : (
                        <p style={{ textAlign: "justify" }}>
                          No team members details given
                        </p>
                      )}
                    </div>
                    <Button
                      variant="contained"
                      color="secondary"
                      onClick={handleDeleteCornUser}
                    >
                      Delete User
                    </Button>
                  </TabPanel>
                  <TabPanel value={value1} index={1}>
                    <Typography variant="h4" backgroundColor="secondary">
                      Hybrid Selection
                    </Typography>

                    {selectedUser && (
                      <div>
                        <Typography variant="h5" gutterBottom>
                          Submitted Forms
                        </Typography>
                        {submittedHybridForms
                          .filter(
                            (form) => form.teamName === selectedUser.teamName,
                          )
                          .map((form, index) => (
                            <Card key={index} sx={{ marginBottom: 2 }}>
                              <CardContent>
                                <Typography variant="h6">
                                  Hybrid: {form.hybrid}
                                </Typography>
                                <Typography variant="body1">
                                  Cost: ${form.cost} per bag
                                </Typography>
                                <Typography variant="body2">
                                  Notes: {form.notes}
                                </Typography>
                                <Typography variant="body2">
                                  Team Name: {form.teamName}
                                </Typography>
                                {hybridTagImages[form.teamName] && (
                                  <Box sx={{ marginTop: 2 }}>
                                    <Box
                                      sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                        marginBottom: 1,
                                      }}
                                    >
                                      <Typography variant="body2">
                                        Hybrid Tag Image:
                                      </Typography>
                                      {!failedImages[form.teamName] && (
                                        <Button
                                          variant="outlined"
                                          size="small"
                                          startIcon={<GetApp />}
                                          onClick={() => {
                                            const imageUrl = `/${hybridTagImages[form.teamName]}`;
                                            const fileName = hybridTagImages[
                                              form.teamName
                                            ]
                                              .split("/")
                                              .pop();
                                            saveAs(
                                              imageUrl,
                                              `${form.teamName}_${fileName}`,
                                            );
                                          }}
                                        >
                                          Download
                                        </Button>
                                      )}
                                    </Box>
                                    <img
                                      src={`/${hybridTagImages[form.teamName]}`}
                                      alt="Hybrid Tag"
                                      style={{
                                        maxWidth: "300px",
                                        maxHeight: "300px",
                                        border: "1px solid #ddd",
                                        borderRadius: "4px",
                                        padding: "5px",
                                      }}
                                      onError={(e) => {
                                        console.error(
                                          "Image failed to load:",
                                          `/${hybridTagImages[form.teamName]}`,
                                        );
                                        e.target.style.display = "none";
                                        setFailedImages((prev) => ({
                                          ...prev,
                                          [form.teamName]: true,
                                        }));
                                      }}
                                    />
                                  </Box>
                                )}
                              </CardContent>
                            </Card>
                          ))}
                      </div>
                    )}
                    {/* Hybrid Selection content */}
                  </TabPanel>
                  <TabPanel value={value1} index={2}>
                    <Typography variant="h4" backgroundColor="secondary">
                      Seeding Rate
                    </Typography>

                    {seedingsubmittedForms.length > 0 && selectedUser && (
                      <div>
                        <Typography variant="h5" gutterBottom>
                          Submitted Forms
                        </Typography>
                        {seedingsubmittedForms
                          .filter(
                            (form) => form.teamName === selectedUser.teamName,
                          )
                          .map((form, index) => (
                            <Card key={index} sx={{ marginBottom: 2 }}>
                              <CardContent>
                                <Typography variant="body1">
                                  Seeding Rate: {form.seedingRate} Seeds/Acre
                                </Typography>
                                <Typography variant="body2">
                                  Notes: {form.notes}
                                </Typography>
                                <Typography variant="body2">
                                  Team Name: {form.teamName}
                                </Typography>
                              </CardContent>
                            </Card>
                          ))}
                      </div>
                    )}

                    {/* Seeding Rate content */}
                  </TabPanel>
                  <TabPanel value={value1} index={3}>
                    <Typography variant="h4" backgroundColor="secondary">
                      Nitrogen Management
                    </Typography>
                    {selectedUser && (
                      <div>
                        <div>
                          {isApplicationTypeConfirmedN && (
                            <div>
                              <p style={{ textAlign: "justify" }}>
                                Selected Application Type: {ApplicationType}
                              </p>
                              {/* Render any additional information about the sensor here */}
                            </div>
                          )}
                          {/* Other component markup */}
                        </div>
                        {isApplicationTypeConfirmed &&
                          ApplicationType === "in-season" && (
                            <>
                              <Typography variant="h6" gutterBottom>
                                Application Data - In-Season
                              </Typography>
                              {NitrogentableData.filter(
                                (app) =>
                                  app.teamName === selectedUser.teamName &&
                                  app.applicationType === "in-season",
                              ).length > 0 &&
                                NitrogentableData.find(
                                  (app) =>
                                    app.teamName === selectedUser.teamName &&
                                    app.applicationType === "in-season",
                                )?.product && (
                                  <Typography
                                    variant="body2"
                                    sx={{ mb: 2, fontStyle: "italic" }}
                                  >
                                    Selected Product:{" "}
                                    {
                                      NitrogentableData.find(
                                        (app) =>
                                          app.teamName ===
                                            selectedUser.teamName &&
                                          app.applicationType === "in-season",
                                      )?.product
                                    }
                                  </Typography>
                                )}

                              {NitrogentableData.filter(
                                (app) =>
                                  app.teamName === selectedUser.teamName &&
                                  app.applicationType === "in-season",
                              ).length > 0 && (
                                <TableContainer>
                                  <Table
                                    id={`table-n2-mgmnt-inseason`}
                                    size="small"
                                  >
                                    <TableHead>
                                      <TableRow>
                                        <TableCell>#</TableCell>
                                        <TableCell>Application Date</TableCell>
                                        <TableCell>Submitted Date</TableCell>
                                        <TableCell>Amount</TableCell>
                                        <TableCell>Placement</TableCell>
                                        <TableCell>Product Option</TableCell>
                                        <TableCell>Applied</TableCell>
                                        <TableCell>
                                          <EditIcon />
                                        </TableCell>
                                      </TableRow>
                                    </TableHead>
                                    <TableBody>
                                      {NitrogentableData.filter(
                                        (app) =>
                                          app.teamName ===
                                            selectedUser.teamName &&
                                          app.applicationType === "in-season",
                                      ) // Filter data for the selected user and "in-season" application type
                                        .sort(
                                          (a, b) =>
                                            new Date(a.date) - new Date(b.date),
                                        )
                                        .map((app, index) => (
                                          <TableRow key={app.id}>
                                            <TableCell>{index + 1}</TableCell>
                                            <TableCell>
                                              {formatDate(app.date)}
                                            </TableCell>
                                            <TableCell>
                                              {formatDate(app.dateToday)}
                                            </TableCell>
                                            <TableCell>{app.amount}</TableCell>
                                            <TableCell>
                                              {app.placement}
                                            </TableCell>
                                            <TableCell>
                                              {app.productOption || "N/A"}
                                            </TableCell>
                                            <TableCell>
                                              <button
                                                style={{
                                                  backgroundColor:
                                                    app.applied === "no"
                                                      ? "red"
                                                      : "green",
                                                  color: "white", // Assuming you want white text for contrast
                                                  border: "none", // Remove default button border styling
                                                  // Add any other styling you need here
                                                }}
                                              >
                                                {app.applied === "no" ? (
                                                  <HighlightOffIcon
                                                    onClick={() =>
                                                      handleNitrogenChangeApplied(
                                                        app.id,
                                                      )
                                                    }
                                                  />
                                                ) : (
                                                  <DoneIcon />
                                                )}
                                              </button>
                                            </TableCell>
                                            <TableCell>
                                              <button
                                                style={{
                                                  backgroundColor:
                                                    app.applied === "no"
                                                      ? "red"
                                                      : "green",
                                                  color: "white", // Assuming you want white text for contrast
                                                  border: "none", // Remove default button border styling
                                                  // Add any other styling you need here
                                                }}
                                              >
                                                {app.applied === "no" ? (
                                                  <DeleteIcon
                                                    onClick={() =>
                                                      handleDeleteNitrogenApplication(
                                                        app.id,
                                                      )
                                                    }
                                                  />
                                                ) : (
                                                  <EditOffIcon />
                                                )}
                                              </button>
                                            </TableCell>
                                          </TableRow>
                                        ))}
                                    </TableBody>
                                  </Table>
                                </TableContainer>
                              )}
                            </>
                          )}

                        {isApplicationTypeConfirmed &&
                          ApplicationType === "controlled-release" && (
                            <>
                              <Typography variant="h6" gutterBottom>
                                Application Data - Controlled-Release
                              </Typography>
                              {NitrogentableData.filter(
                                (app) =>
                                  app.teamName === selectedUser.teamName &&
                                  app.applicationType === "controlled-release",
                              ).length > 0 &&
                                NitrogentableData.find(
                                  (app) =>
                                    app.teamName === selectedUser.teamName &&
                                    app.applicationType ===
                                      "controlled-release",
                                )?.product && (
                                  <Typography
                                    variant="body2"
                                    sx={{ mb: 2, fontStyle: "italic" }}
                                  >
                                    Selected Product:{" "}
                                    {
                                      NitrogentableData.find(
                                        (app) =>
                                          app.teamName ===
                                            selectedUser.teamName &&
                                          app.applicationType ===
                                            "controlled-release",
                                      )?.product
                                    }
                                  </Typography>
                                )}

                              {NitrogentableData.filter(
                                (app) =>
                                  app.teamName === selectedUser.teamName &&
                                  app.applicationType === "controlled-release",
                              ).length > 0 && (
                                <TableContainer>
                                  <Table
                                    id={`table-n2-mgmnt-controlledrelease`}
                                    size="small"
                                  >
                                    <TableHead>
                                      <TableRow>
                                        <TableCell>#</TableCell>
                                        <TableCell>Application Date</TableCell>
                                        <TableCell>Submitted Date</TableCell>
                                        <TableCell>Amount</TableCell>
                                        <TableCell>Placement</TableCell>
                                        <TableCell>Product Option</TableCell>
                                        <TableCell>Applied</TableCell>
                                        <TableCell>
                                          <EditIcon />
                                        </TableCell>
                                      </TableRow>
                                    </TableHead>
                                    <TableBody>
                                      {NitrogentableData.filter(
                                        (app) =>
                                          app.teamName ===
                                            selectedUser.teamName &&
                                          app.applicationType ===
                                            "controlled-release",
                                      ) // Filter data for the selected user and "controlled-release" application type
                                        .sort(
                                          (a, b) =>
                                            new Date(a.date) - new Date(b.date),
                                        )
                                        .map((app, index) => (
                                          <TableRow key={app.id}>
                                            <TableCell>{index + 1}</TableCell>
                                            <TableCell>
                                              {formatDate(app.date)}
                                            </TableCell>
                                            <TableCell>
                                              {formatDate(app.dateToday)}
                                            </TableCell>
                                            <TableCell>{app.amount}</TableCell>
                                            <TableCell>
                                              {app.placement}
                                            </TableCell>
                                            <TableCell>
                                              {app.productOption || "N/A"}
                                            </TableCell>
                                            <TableCell>
                                              <button
                                                style={{
                                                  backgroundColor:
                                                    app.applied === "no"
                                                      ? "red"
                                                      : "green",
                                                  color: "white", // Assuming you want white text for contrast
                                                  border: "none", // Remove default button border styling
                                                  // Add any other styling you need here
                                                }}
                                              >
                                                {app.applied === "no" ? (
                                                  <HighlightOffIcon
                                                    onClick={() =>
                                                      handleNitrogenChangeApplied(
                                                        app.id,
                                                      )
                                                    }
                                                  />
                                                ) : (
                                                  <DoneIcon />
                                                )}
                                              </button>
                                            </TableCell>
                                            <TableCell>
                                              <button
                                                style={{
                                                  backgroundColor:
                                                    app.applied === "no"
                                                      ? "red"
                                                      : "green",
                                                  color: "white", // Assuming you want white text for contrast
                                                  border: "none", // Remove default button border styling
                                                  // Add any other styling you need here
                                                }}
                                              >
                                                {app.applied === "no" ? (
                                                  <DeleteIcon
                                                    onClick={() =>
                                                      handleDeleteNitrogenApplication(
                                                        app.id,
                                                      )
                                                    }
                                                  />
                                                ) : (
                                                  <EditOffIcon />
                                                )}
                                              </button>
                                            </TableCell>
                                          </TableRow>
                                        ))}
                                    </TableBody>
                                  </Table>
                                </TableContainer>
                              )}
                            </>
                          )}
                      </div>
                    )}
                  </TabPanel>
                  <TabPanel value={value1} index={4}>
                    <Typography variant="h4" backgroundColor="secondary">
                      Irrigation Management
                    </Typography>

                    <div>
                      {isApplicationTypeConfirmed && (
                        <div>
                          <p style={{ textAlign: "justify" }}>
                            Selected Irrigation Management option:{" "}
                            {selectedOption}
                          </p>
                          {/* Render any additional information about the sensor here */}
                        </div>
                      )}
                      {/* Other component markup */}
                    </div>
                    {Irrigationapplications.filter(
                      (app) =>
                        app.teamName === selectedUser.teamName &&
                        app.options === "calendar",
                    ).length > 0 && (
                      <>
                        <Typography variant="h6" gutterBottom>
                          Calendar based Irrigation Data
                        </Typography>
                        <Table
                          size="small"
                          aria-label="Irrigation Management Table"
                        >
                          <TableHead>
                            <TableRow>
                              <TableCell>#</TableCell>
                              <TableCell>Application Date</TableCell>
                              <TableCell>Submitted Date</TableCell>
                              <TableCell>Amount</TableCell>
                              <TableCell>Applied</TableCell>
                              <TableCell>
                                <EditIcon />
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {Irrigationapplications.filter(
                              (app) => app.teamName === selectedUser.teamName,
                            )
                              .filter((app) => app.options === "calendar") // Filter data for "calendar" option
                              .sort(
                                (a, b) => new Date(a.date) - new Date(b.date),
                              )
                              .map((app, index) => (
                                <TableRow key={app.id}>
                                  <TableCell>{index + 1}</TableCell>
                                  <TableCell>{formatDate(app.date)}</TableCell>
                                  <TableCell>
                                    {formatDate(app.dateToday)}
                                  </TableCell>
                                  <TableCell>{app.reading}</TableCell>
                                  <TableCell>
                                    <button
                                      style={{
                                        backgroundColor:
                                          app.applied === "no"
                                            ? "red"
                                            : "green",
                                        color: "white", // Assuming you want white text for contrast
                                        border: "none", // Remove default button border styling
                                        // Add any other styling you need here
                                      }}
                                    >
                                      {app.applied === "no" ? (
                                        <HighlightOffIcon
                                          onClick={() =>
                                            handleChangeApplied(app.id)
                                          }
                                        />
                                      ) : (
                                        <DoneIcon />
                                      )}
                                    </button>
                                  </TableCell>

                                  <TableCell>
                                    <button
                                      style={{
                                        backgroundColor:
                                          app.applied === "no"
                                            ? "red"
                                            : "green",
                                        color: "white", // Assuming you want white text for contrast
                                        border: "none", // Remove default button border styling
                                        // Add any other styling you need here
                                      }}
                                    >
                                      {app.applied === "no" ? (
                                        <DeleteIcon
                                          onClick={() =>
                                            handleDeleteApplication(app.id)
                                          }
                                        />
                                      ) : (
                                        <EditOffIcon />
                                      )}
                                    </button>
                                  </TableCell>
                                </TableRow>
                              ))}
                          </TableBody>
                        </Table>
                      </>
                    )}
                    {Irrigationapplications.filter(
                      (app) =>
                        app.teamName === selectedUser.teamName &&
                        app.options === "evapotranspiration",
                    ).length > 0 && (
                      <>
                        <Typography variant="h6" gutterBottom>
                          Evapotranspiration based Irrigation Data
                        </Typography>
                        <Table
                          size="small"
                          aria-label="Irrigation Management Table"
                        >
                          <TableHead>
                            <TableRow>
                              <TableCell>#</TableCell>
                              <TableCell>Application Date</TableCell>
                              <TableCell>Submitted Date</TableCell>
                              <TableCell>Amount</TableCell>
                              <TableCell>Applied</TableCell>
                              <TableCell>
                                <EditIcon />
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {Irrigationapplications.filter(
                              (app) => app.teamName === selectedUser.teamName,
                            )
                              .filter(
                                (app) => app.options === "evapotranspiration",
                              ) // Filter data for "evapotranspiration" option
                              .sort(
                                (a, b) => new Date(a.date) - new Date(b.date),
                              )
                              .map((app, index) => (
                                <TableRow key={app.id}>
                                  <TableCell>{index + 1}</TableCell>
                                  <TableCell>{formatDate(app.date)}</TableCell>
                                  <TableCell>
                                    {formatDate(app.dateToday)}
                                  </TableCell>
                                  <TableCell>{app.reading}</TableCell>
                                  {/* <TableCell>{app.applied}</TableCell> */}
                                  <TableCell>
                                    <button
                                      style={{
                                        backgroundColor:
                                          app.applied === "no"
                                            ? "red"
                                            : "green",
                                        color: "white", // Assuming you want white text for contrast
                                        border: "none", // Remove default button border styling
                                        // Add any other styling you need here
                                      }}
                                    >
                                      {app.applied === "no" ? (
                                        <HighlightOffIcon
                                          onClick={() =>
                                            handleChangeApplied(app.id)
                                          }
                                        />
                                      ) : (
                                        <DoneIcon />
                                      )}
                                    </button>
                                  </TableCell>

                                  <TableCell>
                                    <button
                                      style={{
                                        backgroundColor:
                                          app.applied === "no"
                                            ? "red"
                                            : "green",
                                        color: "white", // Assuming you want white text for contrast
                                        border: "none", // Remove default button border styling
                                        // Add any other styling you need here
                                      }}
                                    >
                                      {app.applied === "no" ? (
                                        <DeleteIcon
                                          onClick={() =>
                                            handleDeleteApplication(app.id)
                                          }
                                        />
                                      ) : (
                                        <EditOffIcon />
                                      )}
                                    </button>
                                  </TableCell>
                                </TableRow>
                              ))}
                          </TableBody>
                        </Table>
                      </>
                    )}
                    <div>
                      {isApplicationTypeConfirmed1 && (
                        <div>
                          <p style={{ textAlign: "justify" }}>
                            Selected Sensor: {soilMoistureSensor}
                          </p>
                          {/* Render any additional information about the sensor here */}
                        </div>
                      )}
                      {/* Other component markup */}
                    </div>
                    {Irrigationapplications.filter(
                      (app) =>
                        app.teamName === selectedUser.teamName &&
                        app.options === "soil-moisture",
                    ).length > 0 && (
                      <>
                        <Typography variant="h6" gutterBottom>
                          Soil - Moisture based Irrigation Data
                        </Typography>

                        <Table
                          size="small"
                          aria-label="Irrigation Management Table"
                        >
                          <TableHead>
                            <TableRow>
                              <TableCell>#</TableCell>
                              <TableCell>Application Date</TableCell>
                              <TableCell>Submitted Date</TableCell>
                              <TableCell>Amount</TableCell>
                              <TableCell>Sensor</TableCell>
                              <TableCell>Applied</TableCell>
                              <TableCell>
                                <EditIcon />
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {Irrigationapplications.filter(
                              (app) => app.teamName === selectedUser.teamName,
                            )
                              .filter((app) => app.options === "soil-moisture") // Filter data for "soil-moisture" option
                              .sort(
                                (a, b) => new Date(a.date) - new Date(b.date),
                              )
                              .map((app, index) => (
                                <TableRow key={app.id}>
                                  <TableCell>{index + 1}</TableCell>
                                  <TableCell>{formatDate(app.date)}</TableCell>
                                  <TableCell>
                                    {formatDate(app.dateToday)}
                                  </TableCell>
                                  <TableCell>{app.reading}</TableCell>
                                  <TableCell>{app.sensorType}</TableCell>
                                  {/* <TableCell>{app.applied}</TableCell> */}
                                  <TableCell>
                                    <button
                                      style={{
                                        backgroundColor:
                                          app.applied === "no"
                                            ? "red"
                                            : "green",
                                        color: "white", // Assuming you want white text for contrast
                                        border: "none", // Remove default button border styling
                                        // Add any other styling you need here
                                      }}
                                    >
                                      {app.applied === "no" ? (
                                        <HighlightOffIcon
                                          onClick={() =>
                                            handleChangeApplied(app.id)
                                          }
                                        />
                                      ) : (
                                        <DoneIcon />
                                      )}
                                    </button>
                                  </TableCell>

                                  <TableCell>
                                    <button
                                      style={{
                                        backgroundColor:
                                          app.applied === "no"
                                            ? "red"
                                            : "green",
                                        color: "white", // Assuming you want white text for contrast
                                        border: "none", // Remove default button border styling
                                        // Add any other styling you need here
                                      }}
                                    >
                                      {app.applied === "no" ? (
                                        <DeleteIcon
                                          onClick={() =>
                                            handleDeleteApplication(app.id)
                                          }
                                        />
                                      ) : (
                                        <EditOffIcon />
                                      )}
                                    </button>
                                  </TableCell>
                                </TableRow>
                              ))}
                          </TableBody>
                        </Table>
                      </>
                    )}
                    {/* Seeding Rate content */}
                  </TabPanel>
                  <TabPanel value={value1} index={5}>
                    <Typography variant="h4" backgroundColor="secondary">
                      Insurance Selection
                    </Typography>
                    {/* Hybrid Selection content */}
                    <Card sx={{ marginBottom: 2 }}>
                      <CardContent>
                        <Typography variant="h6" gutterBottom>
                          Existing Insurance Selection Data
                        </Typography>
                        <ul>
                          {InsuranceFormData.filter(
                            (data) => data.teamName === selectedUser.teamName,
                          ) // Filter data for the selected user
                            .map((data, index) => (
                              <li key={index}>
                                Coverage: {data.coverage}, Level: {data.level}
                              </li>
                            ))}
                        </ul>
                      </CardContent>
                    </Card>
                  </TabPanel>
                  <TabPanel value={value1} index={6}>
                    <Typography variant="h4" backgroundColor="secondary">
                      Marketing Options
                    </Typography>
                    <div className="table-container">
                      <TableContainer>
                        <Table>
                          <TableHead>
                            <TableRow>
                              <TableCell>#</TableCell>
                              <TableCell>Date (EST)</TableCell>
                              <TableCell>Contract Type</TableCell>
                              <TableCell>Quantity Bushels</TableCell>
                              <TableCell>Status</TableCell>
                              <TableCell>Completion date</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {marketingOptions
                              .filter(
                                (option) =>
                                  option.teamName === selectedUser.teamName,
                              ) // Filter data for the selected user
                              .map((option, index) => (
                                <TableRow key={index}>
                                  <TableCell>{index + 1}</TableCell>
                                  <TableCell>
                                    {option.date
                                      ? new Date(
                                          option.date,
                                        ).toLocaleDateString("en-US", {
                                          month: "2-digit",
                                          day: "2-digit",
                                          year: "numeric",
                                        })
                                      : ""}
                                  </TableCell>
                                  <TableCell>{option.contractType}</TableCell>
                                  <TableCell>
                                    {option.quantityBushels}
                                  </TableCell>
                                  <TableCell>
                                    {option.complete === "no"
                                      ? "Pending"
                                      : "Done"}
                                  </TableCell>
                                  <TableCell>
                                    {option.complete === "yes" ? (
                                      <p style={{ textAlign: "justify" }}>
                                        {option.completedon
                                          ? new Date(
                                              option.completedon,
                                            ).toLocaleDateString("en-US", {
                                              month: "2-digit",
                                              day: "2-digit",
                                              year: "numeric",
                                            })
                                          : ""}
                                      </p>
                                    ) : (
                                      <></>
                                    )}
                                  </TableCell>
                                </TableRow>
                              ))}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </div>
                  </TabPanel>
                  <TabPanel value={value1} index={7}>
                    <Typography
                      variant="h4"
                      gutterBottom
                      sx={{ display: "flex", alignItems: "center" }}
                    >
                      <Description sx={{ mr: 1 }} /> Field Data
                    </Typography>
                    <Divider sx={{ mb: 3 }} />

                    <Paper elevation={3} sx={{ mb: 3 }}>
                      <Tabs
                        value={fieldDataTab}
                        onChange={(event, newValue) =>
                          setFieldDataTab(newValue)
                        }
                        aria-label="Field Data Tabs"
                        variant="fullWidth"
                        indicatorColor="secondary"
                        textColor="primary"
                      >
                        <Tab label="Soil Data" />
                        <Tab label="Plant Tissue Data" />
                      </Tabs>
                    </Paper>

                    {/* Soil Data Tab */}
                    {fieldDataTab === 0 && (
                      <Card elevation={3} sx={{ p: 3 }}>
                        <CardContent>
                          <Typography
                            variant="h6"
                            gutterBottom
                            color="primary"
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              mb: 2,
                            }}
                          >
                            <Description sx={{ mr: 1 }} /> Soil Data Entry
                          </Typography>

                          <Typography
                            variant="body2"
                            color="text.secondary"
                            sx={{ mb: 3 }}
                          >
                            Manually enter soil NO3-N measurements at different
                            depths
                          </Typography>

                          <Box component="form" sx={{ mt: 2 }}>
                            {/* Date Input */}
                            <Box sx={{ mb: 3 }}>
                              <TextField
                                label="Sample Date"
                                type="date"
                                value={soilDataDate}
                                onChange={(e) =>
                                  setSoilDataDate(e.target.value)
                                }
                                InputLabelProps={{ shrink: true }}
                                required
                                fullWidth
                                sx={{ maxWidth: 300 }}
                              />
                            </Box>

                            {/* NO3-N Inputs at Different Depths */}
                            <Typography
                              variant="subtitle1"
                              gutterBottom
                              sx={{ fontWeight: "bold", mb: 2 }}
                            >
                              NO3-N Levels (ppm)
                            </Typography>
                            <Box
                              sx={{
                                display: "grid",
                                gridTemplateColumns: {
                                  xs: "1fr",
                                  sm: "repeat(3, 1fr)",
                                },
                                gap: 3,
                                mb: 3,
                              }}
                            >
                              <TextField
                                label='NO3-N at 12"'
                                type="number"
                                value={soilDataNO3N12}
                                onChange={(e) =>
                                  setSoilDataNO3N12(e.target.value)
                                }
                                required
                                fullWidth
                                placeholder="Enter value"
                                helperText="Depth: 12 inches"
                                inputProps={{
                                  min: 0,
                                  step: 0.1,
                                  "aria-label": "NO3-N at 12 inches depth",
                                }}
                                sx={{
                                  "& .MuiOutlinedInput-root": {
                                    "&:hover fieldset": {
                                      borderColor: "#1976d2",
                                    },
                                  },
                                }}
                              />
                              <TextField
                                label='NO3-N at 24"'
                                type="number"
                                value={soilDataNO3N24}
                                onChange={(e) =>
                                  setSoilDataNO3N24(e.target.value)
                                }
                                required
                                fullWidth
                                placeholder="Enter value"
                                helperText="Depth: 24 inches"
                                inputProps={{
                                  min: 0,
                                  step: 0.1,
                                  "aria-label": "NO3-N at 24 inches depth",
                                }}
                                sx={{
                                  "& .MuiOutlinedInput-root": {
                                    "&:hover fieldset": {
                                      borderColor: "#1976d2",
                                    },
                                  },
                                }}
                              />
                              <TextField
                                label='NO3-N at 36"'
                                type="number"
                                value={soilDataNO3N36}
                                onChange={(e) =>
                                  setSoilDataNO3N36(e.target.value)
                                }
                                required
                                fullWidth
                                placeholder="Enter value"
                                helperText="Depth: 36 inches"
                                inputProps={{
                                  min: 0,
                                  step: 0.1,
                                  "aria-label": "NO3-N at 36 inches depth",
                                }}
                                sx={{
                                  "& .MuiOutlinedInput-root": {
                                    "&:hover fieldset": {
                                      borderColor: "#1976d2",
                                    },
                                  },
                                }}
                              />
                            </Box>

                            <Divider sx={{ mb: 2 }} />

                            <Box
                              sx={{
                                display: "flex",
                                gap: 2,
                                justifyContent: "flex-start",
                              }}
                            >
                              <Button
                                variant="contained"
                                color="primary"
                                size="large"
                                onClick={async () => {
                                  if (
                                    !soilDataDate ||
                                    !soilDataNO3N12 ||
                                    !soilDataNO3N24 ||
                                    !soilDataNO3N36
                                  ) {
                                    showNotification(
                                      "Please fill in all required fields",
                                      "warning",
                                    );
                                    return;
                                  }

                                  if (!selectedUser || !selectedUser.teamName) {
                                    showNotification(
                                      "Please select a team first",
                                      "warning",
                                    );
                                    return;
                                  }

                                  try {
                                    const response = await axios.post(
                                      "/api/addManualSoilData",
                                      {
                                        teamName: selectedUser.teamName,
                                        date: soilDataDate,
                                        no3n_12: parseFloat(soilDataNO3N12),
                                        no3n_24: parseFloat(soilDataNO3N24),
                                        no3n_36: parseFloat(soilDataNO3N36),
                                        cropType: "corn",
                                      },
                                      {
                                        headers: {
                                          Authorization: `Bearer ${token}`,
                                        },
                                      },
                                    );

                                    if (response.data.success) {
                                      showNotification(
                                        "Soil data saved successfully!",
                                        "success",
                                      );
                                      setSoilDataDate("");
                                      setSoilDataNO3N12("");
                                      setSoilDataNO3N24("");
                                      setSoilDataNO3N36("");
                                      // Refresh the chart data
                                      fetchUserSoilData();
                                    } else {
                                      showNotification(
                                        response.data.error ||
                                          "Failed to save soil data",
                                        "error",
                                      );
                                    }
                                  } catch (error) {
                                    console.error(
                                      "Error saving soil data:",
                                      error,
                                    );
                                    showNotification(
                                      error.response?.data?.error ||
                                        "Error saving soil data",
                                      "error",
                                    );
                                  }
                                }}
                                sx={{ minWidth: 180 }}
                              >
                                Submit Soil Data
                              </Button>
                              <Button
                                variant="outlined"
                                color="secondary"
                                size="large"
                                onClick={() => {
                                  setSoilDataDate("");
                                  setSoilDataNO3N12("");
                                  setSoilDataNO3N24("");
                                  setSoilDataNO3N36("");
                                }}
                              >
                                Clear Form
                              </Button>
                            </Box>
                          </Box>
                        </CardContent>
                      </Card>
                    )}

                    {/* Soil Data Display Table */}
                    {fieldDataTab === 0 && soilDataList.length > 0 && (
                      <Card elevation={3} sx={{ p: 3, mt: 3 }}>
                        <CardContent>
                          <Typography
                            variant="h6"
                            gutterBottom
                            color="primary"
                            sx={{ mb: 2 }}
                          >
                            Soil Data Records
                          </Typography>
                          <TableContainer>
                            <Table size="small">
                              <TableHead>
                                <TableRow sx={{ backgroundColor: "#f5f5f5" }}>
                                  <TableCell sx={{ fontWeight: "bold" }}>
                                    #
                                  </TableCell>
                                  <TableCell sx={{ fontWeight: "bold" }}>
                                    Date
                                  </TableCell>
                                  <TableCell sx={{ fontWeight: "bold" }}>
                                    NO3-N at 12" (ppm)
                                  </TableCell>
                                  <TableCell sx={{ fontWeight: "bold" }}>
                                    NO3-N at 24" (ppm)
                                  </TableCell>
                                  <TableCell sx={{ fontWeight: "bold" }}>
                                    NO3-N at 36" (ppm)
                                  </TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {(Array.isArray(soilDataList)
                                  ? soilDataList
                                  : []
                                )
                                  .filter(
                                    (data) =>
                                      data.teamName === selectedUser.teamName,
                                  )
                                  .sort(
                                    (a, b) =>
                                      new Date(b.date) - new Date(a.date),
                                  )
                                  .map((data, index) => {
                                    // Parse date without timezone conversion
                                    const dateStr = data.date.split("T")[0];
                                    const [year, month, day] =
                                      dateStr.split("-");
                                    const displayDate = new Date(
                                      year,
                                      month - 1,
                                      day,
                                    ).toLocaleDateString("en-US", {
                                      month: "2-digit",
                                      day: "2-digit",
                                      year: "numeric",
                                    });

                                    return (
                                      <TableRow
                                        key={data.id || index}
                                        sx={{
                                          "&:hover": {
                                            backgroundColor: "#f9f9f9",
                                          },
                                        }}
                                      >
                                        <TableCell>{index + 1}</TableCell>
                                        <TableCell>{displayDate}</TableCell>
                                        <TableCell>{data.no3n_12}</TableCell>
                                        <TableCell>{data.no3n_24}</TableCell>
                                        <TableCell>{data.no3n_36}</TableCell>
                                      </TableRow>
                                    );
                                  })}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </CardContent>
                      </Card>
                    )}

                    {/* Soil Data Visualization Chart */}
                    {fieldDataTab === 0 && userSoilData.length > 0 && (
                      <Card elevation={3} sx={{ p: 3, mt: 3 }}>
                        <CardContent>
                          <Typography
                            variant="h6"
                            gutterBottom
                            color="primary"
                            sx={{ mb: 3, fontWeight: "bold" }}
                          >
                            Soil Nitrate Levels (NO3-N) by Depth - Visualization
                          </Typography>
                          <div
                            ref={soilChartScrollRef}
                            style={{
                              width: "100%",
                              overflowX:
                                window.innerWidth < 768 ? "auto" : "visible",
                            }}
                          >
                            <ResponsiveContainer
                              width={
                                window.innerWidth < 768
                                  ? userSoilData.length * 150
                                  : "100%"
                              }
                              height={450}
                            >
                              <LineChart
                                data={[...userSoilData]
                                  .reverse()
                                  .map((item) => {
                                    const dateStr = item.date.split("T")[0];
                                    const [year, month, day] =
                                      dateStr.split("-");
                                    const displayDate = new Date(
                                      year,
                                      month - 1,
                                      day,
                                    ).toLocaleDateString("en-US", {
                                      month: "2-digit",
                                      day: "2-digit",
                                      year: "numeric",
                                    });

                                    return {
                                      date: displayDate,
                                      "12in": parseFloat(item["NO3-N_12"]) || 0,
                                      "24in": parseFloat(item["NO3-N_24"]) || 0,
                                      "36in": parseFloat(item["NO3-N_36"]) || 0,
                                    };
                                  })}
                                margin={{
                                  top: 40,
                                  right: 30,
                                  left: 20,
                                  bottom: 5,
                                }}
                              >
                                <CartesianGrid
                                  strokeDasharray="3 3"
                                  stroke="#e0e0e0"
                                />
                                <XAxis dataKey="date" stroke="#666" />
                                <YAxis
                                  label={{
                                    value: "NO3-N (ppm)",
                                    angle: -90,
                                    position: "insideLeft",
                                  }}
                                  stroke="#666"
                                />
                                <Tooltip
                                  contentStyle={{
                                    backgroundColor: "#fff",
                                    border: "1px solid #ccc",
                                    borderRadius: "5px",
                                  }}
                                />
                                <Legend />
                                <Line
                                  type="linear"
                                  dataKey="12in"
                                  stroke="#1f77b4"
                                  name="12 inches"
                                  strokeWidth={3}
                                  dot={{ fill: "#1f77b4", r: 5 }}
                                  activeDot={{ r: 7 }}
                                  label={(props) => {
                                    const { x, y, value } = props;
                                    return (
                                      <text
                                        x={x}
                                        y={y - 10}
                                        fill="#1f77b4"
                                        textAnchor="middle"
                                        fontSize={12}
                                        fontWeight="bold"
                                      >
                                        {value}
                                      </text>
                                    );
                                  }}
                                />
                                <Line
                                  type="linear"
                                  dataKey="24in"
                                  stroke="#ff7f0e"
                                  name="24 inches"
                                  strokeWidth={3}
                                  dot={{ fill: "#ff7f0e", r: 5 }}
                                  activeDot={{ r: 7 }}
                                  label={(props) => {
                                    const { x, y, value } = props;
                                    return (
                                      <text
                                        x={x}
                                        y={y - 10}
                                        fill="#ff7f0e"
                                        textAnchor="middle"
                                        fontSize={12}
                                        fontWeight="bold"
                                      >
                                        {value}
                                      </text>
                                    );
                                  }}
                                />
                                <Line
                                  type="linear"
                                  dataKey="36in"
                                  stroke="#2ca02c"
                                  name="36 inches"
                                  strokeWidth={3}
                                  dot={{ fill: "#2ca02c", r: 5 }}
                                  activeDot={{ r: 7 }}
                                  label={(props) => {
                                    const { x, y, value } = props;
                                    return (
                                      <text
                                        x={x}
                                        y={y - 10}
                                        fill="#2ca02c"
                                        textAnchor="middle"
                                        fontSize={12}
                                        fontWeight="bold"
                                      >
                                        {value}
                                      </text>
                                    );
                                  }}
                                />
                              </LineChart>
                            </ResponsiveContainer>
                          </div>
                        </CardContent>
                      </Card>
                    )}

                    {/* Plant Tissue Data Tab */}
                    {fieldDataTab === 1 && (
                      <Card elevation={3} sx={{ p: 3 }}>
                        <CardContent>
                          <Typography variant="h6" gutterBottom color="primary">
                            Plant Tissue Data Entry
                          </Typography>

                          {/* Manual Entry Form */}
                          <Typography
                            variant="subtitle1"
                            fontWeight="bold"
                            gutterBottom
                          >
                            Manual Data Entry
                          </Typography>
                          <Box component="form" sx={{ mt: 2 }}>
                            <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
                              <TextField
                                label="Date"
                                type="date"
                                value={plantTissueDate}
                                onChange={(e) =>
                                  setPlantTissueDate(e.target.value)
                                }
                                InputLabelProps={{ shrink: true }}
                                required
                                fullWidth
                              />
                              <TextField
                                label="N (Nitrogen)"
                                type="number"
                                value={plantTissueN}
                                onChange={(e) =>
                                  setPlantTissueN(e.target.value)
                                }
                                required
                                fullWidth
                              />
                              <TextField
                                label="P (Phosphorus)"
                                type="number"
                                value={plantTissueP}
                                onChange={(e) =>
                                  setPlantTissueP(e.target.value)
                                }
                                required
                                fullWidth
                              />
                              <TextField
                                label="K (Potassium)"
                                type="number"
                                value={plantTissueK}
                                onChange={(e) =>
                                  setPlantTissueK(e.target.value)
                                }
                                required
                                fullWidth
                              />
                            </Box>
                            <Button
                              variant="contained"
                              color="primary"
                              onClick={async () => {
                                if (
                                  !plantTissueDate ||
                                  !plantTissueN ||
                                  !plantTissueP ||
                                  !plantTissueK
                                ) {
                                  showNotification(
                                    "Please fill in all required fields",
                                    "warning",
                                  );
                                  return;
                                }

                                if (!selectedUser || !selectedUser.teamName) {
                                  showNotification(
                                    "Please select a team first",
                                    "warning",
                                  );
                                  return;
                                }

                                try {
                                  const response = await axios.post(
                                    "/api/addManualPlantTissueData",
                                    {
                                      teamName: selectedUser.teamName,
                                      date: plantTissueDate,
                                      nitrogen: parseFloat(plantTissueN),
                                      phosphorus: parseFloat(plantTissueP),
                                      potassium: parseFloat(plantTissueK),
                                      cropType: "corn",
                                    },
                                    {
                                      headers: {
                                        Authorization: `Bearer ${token}`,
                                      },
                                    },
                                  );

                                  if (response.data.success) {
                                    showNotification(
                                      "Plant tissue data saved successfully!",
                                      "success",
                                    );
                                    setPlantTissueDate("");
                                    setPlantTissueN("");
                                    setPlantTissueP("");
                                    setPlantTissueK("");
                                    // Refresh the chart data
                                    fetchUserPlantTissueData();
                                  } else {
                                    showNotification(
                                      response.data.error ||
                                        "Failed to save plant tissue data",
                                      "error",
                                    );
                                  }
                                } catch (error) {
                                  console.error(
                                    "Error saving plant tissue data:",
                                    error,
                                  );
                                  showNotification(
                                    error.response?.data?.error ||
                                      "Error saving plant tissue data",
                                    "error",
                                  );
                                }
                              }}
                            >
                              Submit Plant Tissue Data
                            </Button>
                          </Box>
                        </CardContent>
                      </Card>
                    )}

                    {/* Plant Tissue Data Display Table */}
                    {fieldDataTab === 1 && plantTissueDataList.length > 0 && (
                      <Card elevation={3} sx={{ p: 3, mt: 3 }}>
                        <CardContent>
                          <Typography
                            variant="h6"
                            gutterBottom
                            color="primary"
                            sx={{ mb: 2 }}
                          >
                            Plant Tissue Data Records
                          </Typography>
                          <TableContainer>
                            <Table size="small">
                              <TableHead>
                                <TableRow sx={{ backgroundColor: "#f5f5f5" }}>
                                  <TableCell sx={{ fontWeight: "bold" }}>
                                    #
                                  </TableCell>
                                  <TableCell sx={{ fontWeight: "bold" }}>
                                    Date
                                  </TableCell>
                                  <TableCell sx={{ fontWeight: "bold" }}>
                                    N (Nitrogen)
                                  </TableCell>
                                  <TableCell sx={{ fontWeight: "bold" }}>
                                    P (Phosphorus)
                                  </TableCell>
                                  <TableCell sx={{ fontWeight: "bold" }}>
                                    K (Potassium)
                                  </TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {(Array.isArray(plantTissueDataList)
                                  ? plantTissueDataList
                                  : []
                                )
                                  .filter(
                                    (data) =>
                                      data.teamName === selectedUser.teamName,
                                  )
                                  .sort(
                                    (a, b) =>
                                      new Date(b.date) - new Date(a.date),
                                  )
                                  .map((data, index) => {
                                    // Parse date without timezone conversion
                                    const dateStr = data.date.split("T")[0];
                                    const [year, month, day] =
                                      dateStr.split("-");
                                    const displayDate = new Date(
                                      year,
                                      month - 1,
                                      day,
                                    ).toLocaleDateString("en-US", {
                                      month: "2-digit",
                                      day: "2-digit",
                                      year: "numeric",
                                    });

                                    return (
                                      <TableRow
                                        key={data.id || index}
                                        sx={{
                                          "&:hover": {
                                            backgroundColor: "#f9f9f9",
                                          },
                                        }}
                                      >
                                        <TableCell>{index + 1}</TableCell>
                                        <TableCell>{displayDate}</TableCell>
                                        <TableCell>{data.nitrogen}</TableCell>
                                        <TableCell>{data.phosphorus}</TableCell>
                                        <TableCell>{data.potassium}</TableCell>
                                      </TableRow>
                                    );
                                  })}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </CardContent>
                      </Card>
                    )}

                    {/* Plant Tissue Data Visualization Chart */}
                    {fieldDataTab === 1 && userPlantTissueData.length > 0 && (
                      <Card elevation={3} sx={{ p: 3, mt: 3 }}>
                        <CardContent>
                          <Typography
                            variant="h6"
                            gutterBottom
                            color="primary"
                            sx={{ mb: 3, fontWeight: "bold" }}
                          >
                            Plant Tissue Nutrient Analysis - Visualization
                          </Typography>
                          <div
                            ref={plantTissueChartScrollRef}
                            style={{
                              width: "100%",
                              overflowX:
                                window.innerWidth < 768 ? "auto" : "visible",
                            }}
                          >
                            <ResponsiveContainer
                              width={
                                window.innerWidth < 768
                                  ? userPlantTissueData.length * 200
                                  : "100%"
                              }
                              height={450}
                            >
                              <BarChart
                                data={[...userPlantTissueData]
                                  .reverse()
                                  .map((item) => {
                                    const dateStr = item.date.split("T")[0];
                                    const [year, month, day] =
                                      dateStr.split("-");
                                    const displayDate = new Date(
                                      year,
                                      month - 1,
                                      day,
                                    ).toLocaleDateString("en-US", {
                                      month: "2-digit",
                                      day: "2-digit",
                                      year: "numeric",
                                    });

                                    return {
                                      date: displayDate,
                                      N: parseFloat(item.Nitrogen) || 0,
                                      P: parseFloat(item.Phosphorus) || 0,
                                      K: parseFloat(item.Potassium) || 0,
                                    };
                                  })}
                                margin={{
                                  top: 30,
                                  right: 30,
                                  left: 20,
                                  bottom: 5,
                                }}
                                barCategoryGap="35%"
                              >
                                <CartesianGrid
                                  strokeDasharray="3 3"
                                  stroke="#e0e0e0"
                                />
                                <XAxis dataKey="date" stroke="#666" />
                                <YAxis
                                  label={{
                                    value: "Percentage (%)",
                                    angle: -90,
                                    position: "insideLeft",
                                  }}
                                  stroke="#666"
                                />
                                <Tooltip
                                  contentStyle={{
                                    backgroundColor: "#fff",
                                    border: "1px solid #ccc",
                                    borderRadius: "5px",
                                  }}
                                  itemSorter={(item) => {
                                    const order = { N: 1, P: 2, K: 3 };
                                    return order[item.dataKey] || 999;
                                  }}
                                />
                                <Bar
                                  dataKey="N"
                                  fill="#3b82f6"
                                  name="N (%)"
                                  radius={[8, 8, 0, 0]}
                                  barSize={35}
                                  label={{
                                    position: "top",
                                    fill: "#333",
                                    fontSize: 12,
                                  }}
                                />
                                <Bar
                                  dataKey="P"
                                  fill="#10b981"
                                  name="P (%)"
                                  radius={[8, 8, 0, 0]}
                                  barSize={35}
                                  label={{
                                    position: "top",
                                    fill: "#333",
                                    fontSize: 12,
                                  }}
                                />
                                <Bar
                                  dataKey="K"
                                  fill="#f59e0b"
                                  name="K (%)"
                                  radius={[8, 8, 0, 0]}
                                  barSize={35}
                                  label={{
                                    position: "top",
                                    fill: "#333",
                                    fontSize: 12,
                                  }}
                                />
                                <Legend
                                  wrapperStyle={{ paddingTop: "20px" }}
                                  content={(props) => {
                                    const customOrder = [
                                      { value: "N (%)", color: "#3b82f6" },
                                      { value: "P (%)", color: "#10b981" },
                                      { value: "K (%)", color: "#f59e0b" },
                                    ];
                                    return (
                                      <ul
                                        style={{
                                          display: "flex",
                                          justifyContent: "center",
                                          listStyle: "none",
                                          padding: 0,
                                          margin: 0,
                                        }}
                                      >
                                        {customOrder.map((entry, index) => (
                                          <li
                                            key={`item-${index}`}
                                            style={{
                                              display: "flex",
                                              alignItems: "center",
                                              marginRight: "20px",
                                            }}
                                          >
                                            <svg
                                              width="14"
                                              height="14"
                                              style={{ marginRight: "5px" }}
                                            >
                                              <rect
                                                width="14"
                                                height="14"
                                                fill={entry.color}
                                              />
                                            </svg>
                                            <span style={{ color: "#666" }}>
                                              {entry.value}
                                            </span>
                                          </li>
                                        ))}
                                      </ul>
                                    );
                                  }}
                                />
                              </BarChart>
                            </ResponsiveContainer>
                          </div>
                        </CardContent>
                      </Card>
                    )}
                  </TabPanel>
                  <TabPanel value={value1} index={8}>
                    <Typography
                      variant="h4"
                      gutterBottom
                      sx={{ display: "flex", alignItems: "center" }}
                    >
                      <Description sx={{ mr: 1 }} /> File Management
                    </Typography>
                    <Divider sx={{ mb: 3 }} />

                    <Card elevation={3} sx={{ mb: 3, p: 2 }}>
                      <CardContent>
                        <Typography
                          variant="h6"
                          gutterBottom
                          color="primary"
                          sx={{ display: "flex", alignItems: "center", mb: 2 }}
                        >
                          <CloudUpload sx={{ mr: 1 }} /> Team Specific Files
                        </Typography>
                        <Typography
                          variant="body2"
                          color="text.secondary"
                          sx={{ mb: 2 }}
                        >
                          Choose a file to upload for this team
                        </Typography>

                        <Box sx={{ mb: 2 }}>
                          <FormControl fullWidth>
                            <Typography variant="subtitle2" gutterBottom>
                              Select Category:
                            </Typography>
                            <select
                              id="subFolderSelect"
                              value={selectedSubFolder}
                              onChange={(e) =>
                                setSelectedSubFolder(e.target.value)
                              }
                              style={{
                                padding: "10px",
                                borderRadius: "8px",
                                border: "1px solid #ccc",
                                fontSize: "14px",
                                width: "300px",
                              }}
                            >
                              <option value="" disabled>
                                Select category
                              </option>
                              <option value="Soil Analysis">
                                Soil Analysis
                              </option>
                              <option value="Plant Tissue Analysis">
                                Plant Tissue Analysis
                              </option>
                              <option value="Step Weekly">Step Weekly</option>
                            </select>
                          </FormControl>
                        </Box>

                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 2,
                            mt: 2,
                          }}
                        >
                          <Button
                            variant="outlined"
                            component="label"
                            startIcon={<InsertDriveFile />}
                          >
                            Choose File
                            <input
                              type="file"
                              id="defaultFileInput1"
                              onChange={handleFileChange}
                              hidden
                            />
                          </Button>
                          {selectedFile && (
                            <Chip
                              label={selectedFile.name}
                              onDelete={() => {
                                setSelectedFile(null);
                                document.getElementById(
                                  "defaultFileInput1",
                                ).value = "";
                              }}
                              color="primary"
                              variant="outlined"
                            />
                          )}
                          <Button
                            variant="contained"
                            onClick={() =>
                              handleteamFileUpload(selectedUser.teamName)
                            }
                            disabled={!selectedFile || uploadingFile === "team"}
                            startIcon={
                              uploadingFile === "team" ? (
                                <CircularProgress size={20} />
                              ) : (
                                <CloudUpload />
                              )
                            }
                          >
                            {uploadingFile === "team"
                              ? "Uploading..."
                              : "Upload File"}
                          </Button>
                        </Box>
                      </CardContent>
                    </Card>
                    <Container>
                      <Paper elevation={3} style={{ padding: "20px" }}>
                        <Typography
                          variant="h5"
                          gutterBottom
                          sx={{ display: "flex", alignItems: "center" }}
                        >
                          <Description sx={{ mr: 1 }} /> All Files
                        </Typography>
                        <Divider sx={{ mb: 2 }} />

                        <Typography variant="h6" gutterBottom color="primary">
                          General Files:
                        </Typography>
                        <List>
                          {defaultfiles
                            .filter(
                              (fileName) =>
                                fileName !== "metadata.json" &&
                                fileName !== "Thumbs.db",
                            )
                            .map((fileName, index) => (
                              <ListItem
                                key={index}
                                sx={{
                                  border: "1px solid #e0e0e0",
                                  borderRadius: "8px",
                                  mb: 1,
                                  "&:hover": { bgcolor: "#f5f5f5" },
                                }}
                              >
                                <InsertDriveFile
                                  sx={{ mr: 2, color: "#1976d2" }}
                                />
                                <ListItemText primary={fileName} />
                                <Button
                                  variant="contained"
                                  color="primary"
                                  size="small"
                                  disabled={!!loadingDownload[fileName]}
                                  onClick={() =>
                                    handleDownload(
                                      `downloadDefaultFile/${fileName}`,
                                    )
                                  }
                                  startIcon={
                                    loadingDownload[fileName] ? null : (
                                      <GetApp />
                                    )
                                  }
                                  sx={{ mr: 1 }}
                                >
                                  {loadingDownload[fileName] ? (
                                    <CircularProgress
                                      size={20}
                                      color="inherit"
                                    />
                                  ) : (
                                    "Download"
                                  )}
                                </Button>
                                <IconButton
                                  color="error"
                                  onClick={() => handledefaultDelete(fileName)}
                                  size="small"
                                >
                                  <Delete />
                                </IconButton>
                              </ListItem>
                            ))}
                        </List>

                        <Typography
                          variant="h6"
                          gutterBottom
                          color="primary"
                          sx={{ mt: 3 }}
                        >
                          Insurance Files:
                        </Typography>
                        <List>
                          {insurancefiles
                            .filter(
                              (fileName) =>
                                fileName !== "metadata.json" &&
                                fileName !== "Thumbs.db",
                            )
                            .map((fileName, index) => (
                              <ListItem
                                key={index}
                                sx={{
                                  border: "1px solid #e0e0e0",
                                  borderRadius: "8px",
                                  mb: 1,
                                  "&:hover": { bgcolor: "#f5f5f5" },
                                }}
                              >
                                <InsertDriveFile
                                  sx={{ mr: 2, color: "#1976d2" }}
                                />
                                <ListItemText primary={fileName} />
                                <Button
                                  variant="contained"
                                  color="primary"
                                  size="small"
                                  disabled={!!loadingDownload[fileName]}
                                  onClick={() =>
                                    handleDownload(
                                      `downloadInsuranceFile/${fileName}`,
                                    )
                                  }
                                  startIcon={
                                    loadingDownload[fileName] ? null : (
                                      <GetApp />
                                    )
                                  }
                                  sx={{ mr: 1 }}
                                >
                                  {loadingDownload[fileName] ? (
                                    <CircularProgress
                                      size={20}
                                      color="inherit"
                                    />
                                  ) : (
                                    "Download"
                                  )}
                                </Button>
                                <IconButton
                                  color="error"
                                  onClick={() =>
                                    handleinsuranceDelete(fileName)
                                  }
                                  size="small"
                                >
                                  <Delete />
                                </IconButton>
                              </ListItem>
                            ))}
                        </List>

                        <Typography
                          variant="h6"
                          gutterBottom
                          color="primary"
                          sx={{ mt: 3 }}
                        >
                          Marketing Files:
                        </Typography>
                        <List>
                          {marketingfiles
                            .filter(
                              (fileName) =>
                                fileName !== "metadata.json" &&
                                fileName !== "Thumbs.db",
                            )
                            .map((fileName, index) => (
                              <ListItem
                                key={index}
                                sx={{
                                  border: "1px solid #e0e0e0",
                                  borderRadius: "8px",
                                  mb: 1,
                                  "&:hover": { bgcolor: "#f5f5f5" },
                                }}
                              >
                                <InsertDriveFile
                                  sx={{ mr: 2, color: "#1976d2" }}
                                />
                                <ListItemText primary={fileName} />
                                <Button
                                  variant="contained"
                                  color="primary"
                                  size="small"
                                  disabled={!!loadingDownload[fileName]}
                                  onClick={() =>
                                    handleDownload(
                                      `downloadMarketingFile/${fileName}`,
                                    )
                                  }
                                  startIcon={
                                    loadingDownload[fileName] ? null : (
                                      <GetApp />
                                    )
                                  }
                                  sx={{ mr: 1 }}
                                >
                                  {loadingDownload[fileName] ? (
                                    <CircularProgress
                                      size={20}
                                      color="inherit"
                                    />
                                  ) : (
                                    "Download"
                                  )}
                                </Button>
                                <IconButton
                                  color="error"
                                  onClick={() =>
                                    handlemarketingDelete(fileName)
                                  }
                                  size="small"
                                >
                                  <Delete />
                                </IconButton>
                              </ListItem>
                            ))}
                        </List>

                        <Typography
                          variant="h6"
                          gutterBottom
                          color="primary"
                          sx={{ mt: 3 }}
                        >
                          Team Specific Files:
                        </Typography>
                        {deleteStatusMessaget && (
                          <div className="status-message">
                            {deleteStatusMessaget}
                          </div>
                        )}
                        <List>
                          {teamfiles
                            .filter(
                              (fileName) => !fileName.startsWith("profile."),
                            )
                            .filter((fileName) => fileName !== "Thumbs.db")
                            .map((fileName, index) => (
                              <ListItem
                                key={index}
                                sx={{
                                  border: "1px solid #e0e0e0",
                                  borderRadius: "8px",
                                  mb: 1,
                                  "&:hover": { bgcolor: "#f5f5f5" },
                                }}
                              >
                                <InsertDriveFile
                                  sx={{ mr: 2, color: "#1976d2" }}
                                />
                                <ListItemText primary={fileName} />
                                <Button
                                  variant="contained"
                                  color="primary"
                                  size="small"
                                  disabled={!!loadingDownload[fileName]}
                                  onClick={() =>
                                    handleDownload(
                                      `downloadTeamFile/${selectedUser.teamName}/${fileName}`,
                                    )
                                  }
                                  startIcon={
                                    loadingDownload[fileName] ? null : (
                                      <GetApp />
                                    )
                                  }
                                  sx={{ mr: 1 }}
                                >
                                  {loadingDownload[fileName] ? (
                                    <CircularProgress
                                      size={20}
                                      color="inherit"
                                    />
                                  ) : (
                                    "Download"
                                  )}
                                </Button>
                                <IconButton
                                  color="error"
                                  size="small"
                                  onClick={() =>
                                    handleTeamFileDelete(
                                      fileName,
                                      selectedUser.teamName,
                                    )
                                  }
                                >
                                  <Delete />
                                </IconButton>
                              </ListItem>
                            ))}
                        </List>
                      </Paper>
                    </Container>
                    {/* Hybrid Selection content */}
                  </TabPanel>
                  <TabPanel value={value1} index={9}>
                    <Typography variant="h4" backgroundColor="secondary">
                      Weather
                    </Typography>
                    <div style={{ overflowX: "auto", paddingTop: "25px" }}>
                      <div style={{ width: "1500px", height: "600px" }}>
                        <RainfallChart />
                      </div>
                    </div>
                  </TabPanel>
                </div>
              </div>
            )}
          </Box>
        </div>
      </div>
      {/* </TabPanel> */}
      <NotificationMessage
        open={notification.open}
        onClose={handleCloseNotification}
        message={notification.message}
        severity={notification.severity}
      />
    </div>
  );
}

export default CornAdminPage;
